import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import EmptyState from 'Components/EmptyState/EmptyState';
import GDTableSummaryRow from 'Components/GDTable/GDTableSummaryRow';
import OverviewPane from 'Components/OverviewPane';
import HollowButton from 'Components/Button/HollowButton';
import BVLoader20 from 'Components/loaders/BVLoader/BVLoader20';
import BookMarkIcon from 'Containers/Icon/BookMarkIcon/BookMarkIcon';
import SelectInput from 'Components/forms/select-input';
import { Divider } from 'antd';
import './CaseLanding.scss';
import FinancialsBanner from 'Components/cards/FinancialsBanner/FinancialsBanner';
import GDColorCodedCell from 'Components/GDTable/GDColorCodedCell/GDColorCodedCell';
import ResponseBanner from 'Components/cards/ResponseBanner';
import TimeLineSection from 'Containers/TimeLineSection';
import LockIcon from 'Assets/img/landingpage-lock.svg';
import financialsLogo from 'Components/cards/FinancialsBanner/icon_warning.svg';
import { openNotificationToast } from 'Utils/notificationMessageUtils.jsx';
import InformationBubble from 'Components/information-bubble/InformationBubble';
import DueDate from 'Components/DueDate/DueDate';
import moment from 'moment';
import counterpart from 'counterpart';
// CONTAINERS
import ActionPane from 'Containers/ActionPane/ActionPane';
import IssuerActions from 'Containers/IssuerActions/IssuerActions';
import * as ActionConstants from 'Containers/IssuerActions/ActionConstants.js';

// API FUNCTIONS
import { updateActionPaneData } from 'Apis/actionPaneApi';
import { postBookMarkCase, undoBookMarkCase } from 'Apis/queueManagerApi.js';
import FormGroupControl from 'Components/forms/form-group-control/FormGroupControl';

//Utils
import * as KeyConstants from 'Utils/constants/keyConstants.js';
import { getFormattedSchemeData } from 'Utils/formatting.js';
import { getUrlSearchParamValue } from 'Utils/urlUtils';

// ACTIONS
import { addInternalCaseNotificationBanner, closeNotificationBanner } from 'Actions/notificationAction';
import { addCaseToRecent } from 'Actions/recentCasesAction.js';
import { addCurrentCaseNumber } from 'Actions/searchTransactionAction.js';
import { resetNestedFieldSelectorData } from 'Actions/nestedFieldSelectorAction.js';
import { setDrawerOpenFlag } from 'Actions/drawerAction';
import GDDetailView from 'Components/GDDetailView';
import QuestionireDetailView from 'Components/QuestionireDetailView';

import { loadState } from '../../store/browserStorage';

import { setDataSearchTrasactionGridProp, toggleAppSearchPanelAction, setRelatedGridLoadedAction } from 'Actions/toggleAppSearchPanelAction';
import { setMerchantDetailsAction } from 'Actions/setMerchantDetailsAction';
import { setSearchOpenFlag } from 'Actions/drawerAction';
import { setAmexDisputeReasonCode } from 'Actions/reasonCodeAction';
import { setActiveStageIndicatorSettingsOpenFlag } from 'Actions/drawerAction';

import { isUserAuthenticatedSelector } from '../../selectors';
import Button from 'Components/Button/Button';
import { COLORS } from "Constants/BIDashboardConstants"

// CONFIGURATION
import {
  getOverviewData,
  getSummaryData,
  getSelectionActionList,
  getActionPanelDetailToShow,
  getUpdatedSelectionActionList,
  getUpdatedActionPanelDetailToShow,
  getDrawerData,
  getOp1CaseDetails,
  getWexCaseDetails,
  getLTypeCaseDetails,
  getOutgoingArbitrationProsaList,
  getOutgoingArbitrationProsaListShow,
  NON_TAKE_ACTION_QUEUES,
  getTranslations,
  getRelatedCasesFilterList,
} from './configStructure';

import { getAuthData, getCaseData, getCardBrandData, getTranData, getCreditTranData } from 'Apis/caseAPI';

// STYLES
import 'antd/dist/reset.css';
import './CaseLanding.scss';
import { setCaseStageId } from 'Utils/localStorageUtils';
import { getQuestionnaireDetails } from '../../api/caseDataAPI';
import { updateOp1CaseData, updateLTypeCaseData, updateWexCaseData } from '../../api/caseManagerAPI';
import { getToken } from '../../api/tokenizeFilterElement';
import CaseLandingGetNextHeader from 'Components/CaseLandingGetNextHeader/CaseLandingGetNextHeader';
import { downloadFile } from 'Utils/exportFunctionality.js';
import { postActiveFilters } from '../../api/caseDataAPI';
import { submitTakeActionResponse } from 'Apis/serviceCaseActionApi';
import {
  getRelatedCaseSearchData
} from 'Apis/searchFilterApi';
import { fetchDataColumns } from 'Actions/dataColumnsAction';
import {
  queueMetaData,
  addIconsToGDTableHeadersList,
} from '../QueueManagementLanding/configStructure';
import { gotoNewTabCaseLandingPage } from 'Utils/newTabUtils.jsx';
import { exportRelatedCasesData } from 'Apis/exportApi';
import GridAccordion from 'Components/GridAccordion/GridAccordion';
import { fetchAmexDisputeStages, fetchCase, fetchOp1Case, resetCaseRevisitFlag, resetCaseUpdateFlag, revisitCase, unloadCaseAsActive, unloadCaseInfo } from 'Actions/caseActions';
import { trim } from 'Utils/lodashUtils';
import { getAcquirerAccessList } from 'Utils/permissionsUtils';
import { UNIDENTIFIED_STAGE, EXIT_ACTION, EXIT_CASE_LIST, OP1_REASON_CODE, WEX_QUEUE_ID, CASE_HEADER_CONTAINER, CASE_HEADER_INNER, MAIN_CONTENT_HEADER, CASELANDING_PATH } from 'Constants/caseDetailConstants';

import ImagePortal from '../ImagePortal/ImagePortal';

const __UNIDENTIFIED_STAGE__ = 'Unidentified-Stage';
const __EXIT_ACTION__ = 'Exit Case';
const __EXIT_CASE_LIST__ = [
  { id: '15', viewCode: 'EC', value: __EXIT_ACTION__, text: __EXIT_ACTION__, color: '#007dc3' }
];

const __OP1_REASON_CODE__ = 'OP1';
const _WEX_QUEUE_ID_ = 80;

export class CaseLanding extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isAccordionOpen: true,
      isVisible: false,
      caseLandingData: {},
      metaData: [],
      summaryData: getSummaryData(),
      caseNumber: '',
      isExpanded: true,
      dataErr: true,
      selectList: [],
      sortArr: getRelatedCasesFilterList().defaultSort,
      selectedItem: null,
      actionHeader: '',
      actionDescription: '',
      actionSelectionList: [],
      actionPrimaryButtonText: '',
      showProgressButton: false,
      actionPanelDetailList: [],
      selectedActionPanelDetailItem: {},
      isDataUploaded: false,
      caseStatus: '',
      isIssuer: false,
      accountingDetails: [],
      divHeightArray: [],
      data: {
      },
      showBanner: false,
      showRedBanner: false,
      showUnlinkSuccess: false,
      showUnlinkFailure: false,
      historyData: [],
      historyDataErr: false,
      historyDataLoading: false,
      bookMarkedInitial: [],
      isReadOnly: false,
      disableTakeAction: false,
      caseStageId: 0,
      emptyStateHeading: 'Data not available.',
      emptyStateDescription: 'Please try again later.',
      drawerOpen: false,
      questionDrawer: false,
      configId: 0,
      drawerData: {},
      isdataLoading: true,
      drawerdataErr: true,
      isLoading: true,
      isMerchantDetailsLoading: false,
      isBankDetailsLoading: false,
      isTakeActionLoading: false,
      isActionPagesLoading: false,
      isAccountDataLoading: false,
      isTransactionDetailsLoading: false,
      isAuthDetailLoading: false,
      questionireData: {},
      isrelatedSearchLoading: false,
      isrelatedSearchLoaded: false,
      isrelatedSearchDataError: false,
      filterText: '',
      exporting: false,
      setSize: false,
      isLoadingComplete: true,
      isGridOpen: false,
      caseData: [],
      caseHeaderDrawer: false,
      isCaseFailedToLoad: false
    };
    this.attachBindings();
  }
  componentDidMount() {
    this.props.fetchDataColumns(getRelatedCasesFilterList().pageId);
    document.addEventListener('keydown', this.onKeyPress);
    document.addEventListener('keypress', this.onKeyPress);
    this.props.setDataSearchTrasactionGridProp(false, true, false);
    window.addEventListener('beforeunload', this.removeCurrentLockedCase);
    this.getCaseDetails();
    const auth = loadState('auth');
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.isExceptionCaseUpdated && this.state.isExceptionCaseUpdated != prevState.isExceptionCaseUpdated) {
      this.props.history.push(
        `queue/6/caseselection/${this.state.exceptionCaseNumber}`
      );
    }

    if (this.props.amexDisputeStages.length > 0 && prevProps.amexDisputeStages !== this.props.amexDisputeStages) {
      this.setState({
        exceptionQueueCaseDetail: this.setDisputeStageList(getLTypeCaseDetails(), this.props.amexDisputeStages)
      });
    }
    if (window.location.href.indexOf(CASELANDING_PATH) != -1) {
      let pathArray = window.location.href.split(CASELANDING_PATH);
      if (pathArray[1] && !pathArray[1].includes('casestage/')) {
        let caseNumber = pathArray[1]?.split("?")[0];
        if (!!caseNumber) {
          if (prevProps.activeCases.indexOf(Number(caseNumber)) !== -1
            && this.props.activeCases.indexOf(Number(caseNumber)) === -1
          ) {
            const notificationContent = <div style={{ color: 'black' }}>
              <b>Read Only Mode.</b>
              <p>This case has been released.</p>
            </div>
            this.setState({
              isReadOnly: true,
            })
            this.onReadOnly(notificationContent);
          }
          if (this.props.openCases.length > 0
            && this.props.openCases.some(openCase => openCase.caseDetail.caseNumber === Number(caseNumber))
            && this.updateCaseDetails(prevProps, Number(caseNumber))
          ) {
            this.props.setDataSearchTrasactionGridProp(false, true, false);
            let openCase = this.props.openCases.find(
              (openCase) => openCase.caseDetail.caseNumber === Number(caseNumber)
            );
            if (openCase.failedToLoad) {
              this.setState({
                isLoading: false,
                isCaseFailedToLoad: true,
                dataErr: true,
              });
            } else {
              this.setCaseLandingData(openCase);
              const currCaseLock = this.props.openCases.find(openCase => openCase.caseDetail.caseNumber === Number(caseNumber)).lockCaseInfo;
              if (currCaseLock.data && currCaseLock.data.isCaseLocked) {
                const notificationContent = <div style={{ color: 'black' }}>
                  <b>Read Only Mode.</b>
                  <p>This case is currently being worked by {currCaseLock.data.userName}</p>
                </div>
                this.onReadOnly(notificationContent);
                this.setState({
                  userName: currCaseLock.data.userName,
                  isReadOnly: currCaseLock.data.isCaseLocked,
                  disableTakeAction: true
                });
              }
              else if (currCaseLock === 412) {
                this.setState({ disableTakeAction: true }, () => {
                  const notificationContent = <div style={{ color: 'black' }}>
                    <p>You have reached the maximum number of allowable open cases.  To continue, you will need to close some cases.</p>
                  </div>
                  const notificationMessageSuccess = {
                    type: 'info',
                    placement: 'topRight',
                    messageWidth: 250,
                    byDefault: true,
                    duration: 10,
                    content: notificationContent,
                  }
                  openNotificationToast(notificationMessageSuccess);
                });
              }
            }

          }
        }
      }
      else if (pathArray[1] && pathArray[1].includes('casestage/')) {
        let caseStage = pathArray[1].split('casestage/')[1];
        let currentCase = this.props.openCases.find(openCase => openCase.caseDetail.caseStageId === caseStage);
        if (currentCase && this.props.openCases.length > 0
          && this.props.openCases.some(openCase => openCase.caseDetail.caseStageId == caseStage)
          && this.updateCaseStageDetails(prevProps, Number(caseStage))) {
          this.props.setDataSearchTrasactionGridProp(false, true, false);
          this.updateExceptionCaseDetails(currentCase);
        }
      }
    }
  }

  getCaseDetails() {
    if (window.location.href.indexOf(CASELANDING_PATH) != -1) {
      let pathArray = window.location.href.split(CASELANDING_PATH);
      if (pathArray[1] && !pathArray[1].includes('casestage/')) {
        let caseNumber = pathArray[1]?.split("?")[0];
        if (!!caseNumber) {
          this.props.fetchCase(caseNumber, false);
        }
      }
      else if (pathArray[1] && pathArray[1].includes('casestage/')) {
        let caseStage = pathArray[1].split('casestage/')[1];
        this.props.fetchOp1Case(caseStage);
      }
    }
  }

  updateCaseDetails(prevProps, caseNumber) {
    if (Number(prevProps.caseNumber) !== caseNumber) {
      this.props.setActiveStageIndicatorSettingsOpenFlag(false);
      return true;
    }
    else if (!prevProps.openCases.some(openCase => openCase.caseDetail.caseNumber == caseNumber)) {
      this.props.setActiveStageIndicatorSettingsOpenFlag(false);
      return true;
    }
    else if (
      prevProps.openCases.some(openCase => openCase.caseDetail.caseNumber == caseNumber) &&
      !prevProps.openCases.find(openCase => openCase.caseDetail.caseNumber == caseNumber).caseUpdated
      && this.props.openCases.find(openCase => openCase.caseDetail.caseNumber == caseNumber).caseUpdated
    ) {
      this.props.resetCaseUpdateFlag(caseNumber);
      return true;
    }
    else if (
      prevProps.openCases.some(openCase => openCase.caseDetail.caseNumber == caseNumber) &&
      prevProps.openCases.find(openCase => openCase.caseDetail.caseNumber == caseNumber).isCaseRevisited
    ) {
      this.props.resetCaseRevisitFlag(caseNumber);
      return true;
    }
    else {
      return false;
    }
  }

  updateCaseStageDetails(prevProps, caseStageId) {
    if (Number(prevProps.caseStageId) !== caseStageId) {
      return true;
    }
    else if (!prevProps.openCases.some(openCase => openCase.caseDetail.caseStageId == caseStageId)) {
      return true;
    }
    else if (
      prevProps.openCases.some(openCase => openCase.caseDetail.caseStageId == caseStageId) &&
      !prevProps.openCases.find(openCase => openCase.caseDetail.caseStageId == caseStageId).caseUpdated
      && this.props.openCases.find(openCase => openCase.caseDetail.caseStageId == caseStageId).caseUpdated
    ) {
      this.props.resetCaseUpdateFlag(caseStageId);
      return true;
    }
    else {
      return false;
    }
  }

  updateExceptionCaseDetails(currentCase) {
    let queueId = (this.props.location.state !== undefined ? this.props.location.state.queueId : sessionStorage.getItem('queueid'));
    let exceptionQueueCaseDetail = (queueId == WEX_QUEUE_ID ? getWexCaseDetails() : getOp1CaseDetails());
    this.setState({
      caseStageId: currentCase.caseStageDetail.caseStageId,
      exceptionQueueCaseDetail,
      isOp1OrWex: true,
      cardBrandMerchantNumber: currentCase.caseDetail.cardBrandMerchantNumber,
      sellerId: currentCase.caseDetail.sellerId,
      caseLandingData: currentCase,
      accountingDetails: currentCase.accountDetail,
      takeActions: currentCase.takeActions,
      takeActionPageDetail: currentCase.takeActionPageDetail,
      isLoading: false,
      dataErr: false,
      amexDisputeReasonCode: OP1_REASON_CODE,
      selectList: EXIT_CASE_LIST
    });
  }

  /**
   * This method is used to set ltype case details
   * @param {*} exceptionCaseDetail 
   */
  setLTypeCasedetails(exceptionCaseDetail) {
    if ((exceptionCaseDetail.disputeStageName && exceptionCaseDetail.disputeStageName == UNIDENTIFIED_STAGE) || (exceptionCaseDetail.caseStageDetail_disputeStageName && exceptionCaseDetail.caseStageDetail_disputeStageName == UNIDENTIFIED_STAGE)) {
      let amexLTypeQueueCaseDetail = getLTypeCaseDetails();
      if (this.props.amexDisputeStages.length > 0) {
        amexLTypeQueueCaseDetail = this.setDisputeStageList(amexLTypeQueueCaseDetail, this.props.amexDisputeStages);
      }
      else {
        this.props.fetchAmexDisputeStages();
      }
      this.setState({
        isLtype: true,
        exceptionQueueCaseDetail: amexLTypeQueueCaseDetail,
        amexDisputeReasonCode: exceptionCaseDetail.disputeReasonCode ? exceptionCaseDetail.disputeReasonCode : exceptionCaseDetail.caseStageDetail_disputeReasonCode,
        exceptionCaseDetail
      });
    } else {
      this.setState({
        isLtype: false,
      })
    }
  }

  toCloseRelatedTransactionGrid = () => {
    this.props.setSearchOpenFlag(false);
    this.props.setSearchType(null);  // coming from main.js as props
    this.props.toggleAppSearchPanelAction(false);
    this.props.setRelatedGridLoadedAction(false);
  }

  componentWillUnmount() {
    this.toCloseRelatedTransactionGrid();

    window.document.title = 'Disputes Management';
    document.removeEventListener('keydown', this.onKeyPress);
    document.removeEventListener('keypress', this.onKeyPress);
    window.removeEventListener('beforeunload', this.removeCurrentLockedCase);
    this.state.intervalTiming && clearInterval(this.state.intervalTiming);
    const role = this.props.auth.user.role.key;
    const internalEmployees = ['DiMS_INTERNAL_EMPLOYEE'];
    let isInternalUser = false;
    if (internalEmployees.findIndex(internalEmp => internalEmp === role) !== -1) {
      isInternalUser = true;
    }
    if (this.state.caseLandingData.caseDetail && !isInternalUser) {
      this.props.revisitCase(this.state.caseLandingData.caseDetail.caseNumber);
      // this.props.unloadCaseInfo(this.state.caseLandingData.caseDetail.caseNumber);
      // this.props.unloadCaseAsActive(this.state.caseLandingData.caseDetail.caseNumber, this.state.caseLandingData.caseStageDetail.caseStageId);
    }
    this.props.addCurrentCaseNumber(0);
  }

  componentWillUpdate(nextProps, nextStates) {
    if (this.state.bookMarkedInitial.length == 0 && this.state.caseLandingData.caseDetail && this.state.caseLandingData.caseDetail.bookmarkBy !== undefined) {
      if (this.state.caseLandingData.caseDetail.bookmarkBy) {
        this.setState({
          isBookMarked: false,
          bookMarkedInitial: 1,
        });
      }
      else {
        this.setState({
          isBookMarked: true,
          bookMarkedInitial: 1,
        });
      }
    }
    const currentCaseDetails = nextProps?.openCases?.find((openCase) => openCase?.caseDetail?.caseNumber === Number(nextProps?.caseNumber));
    if (this.state.caseLandingData?.caseHistory && currentCaseDetails && (this.state.caseLandingData?.caseHistory?.length !== currentCaseDetails?.caseHistory?.length)) {
      this.setState({
        caseLandingData: currentCaseDetails,
      });
    }
  }


  findHeight(id, resetArray) {
    const data = this.state.isExpanded ? getOverviewData() : getOverviewData().filter((element) => element.defaultIsVisible == true);
    let currentId = data.map(element => element.id).find((item) => { return id === item });
    let height = document.getElementById(currentId).offsetHeight;
    this.setState((state) => {
      return { divHeightArray: resetArray ? [] : state.divHeightArray.concat(height) };
    });
    id === 3 && this.toggle();
  }

  componentWillReceiveProps(nextProps) {
    if (this.state.caseLandingData.caseDetail && this.state.caseLandingData.caseDetail.bookmarkBy !== undefined) {
      if (this.state.caseLandingData.caseDetail.bookmarkBy) {
        this.setState({
          isBookMarked: false,
          bookMarkedInitial: 1,
        });
      } else {
        this.setState({
          isBookMarked: true,
          bookMarkedInitial: 1,
        });
      }
    }
    if (this.props.caseNumber && nextProps.caseNumber && nextProps.caseNumber !== this.props.caseNumber) {
      /**
       * Window will reload so that it can pick up new height of overviewpane
       */
      if (this.props.location.state?.callingComponent) {
        reloadPage();
      }
      this.setState({
        isLoading: true,
        isGridOpen: false,
        caseData: [],
        isrelatedSearchLoaded: false
      });
      if (!this.props.openCases.some(openCase => openCase.caseDetail.caseNumber === Number(nextProps.caseNumber))) {
        this.props.fetchCase(Number(nextProps.caseNumber), false);
      }
      this.toCloseRelatedTransactionGrid();
    }
  }

  attachBindings() {
    this.onSelectionChange = this.onSelectionChange.bind(this);
    this.renderResponseBanner = this.renderResponseBanner.bind(this);
    this.resetActionPane = this.resetActionPane.bind(this);
    this.setCaseStatus = this.setCaseStatus.bind(this);
    this.unpendCase = this.unpendCase.bind(this);
    this.gotoExtraCaseDetailsPage = this.gotoExtraCaseDetailsPage.bind(this);
    this.isTakeActionItemSelected = this.isTakeActionItemSelected.bind(this);
    this.filterTakeActionList = this.filterTakeActionList.bind(this);
    this.findHeight = this.findHeight.bind(this);
    this.toggleBookMarkIcon = this.toggleBookMarkIcon.bind(this);
    this.onKeyPress = this.onKeyPress.bind(this);
    this.resetCaseData = this.resetCaseData.bind(this);
    this.onReadOnly = this.onReadOnly.bind(this);
    this.removeCurrentLockedCase = this.removeCurrentLockedCase.bind(this);
    this.performTakeAction = this.performTakeAction.bind(this);
    this.getCaseDrawerData = this.getCaseDrawerData.bind(this);
    this.getAuthDrawerData - this.getAuthDrawerData.bind(this);
    this.getTranDrawerData = this.getTranDrawerData.bind(this);
    this.getSchemeDrawerData = this.getSchemeDrawerData.bind(this);
    this.getApiDrawerData = this.getApiDrawerData.bind(this);
    this.gotoNewTabPage = this.gotoNewTabPage.bind(this);
    this.submitAndUpdateExceptionCases = this.submitAndUpdateExceptionCases.bind(this);
    this.goToPreviousPage = this.goToPreviousPage.bind(this);
    this.submitExceptionInformation = this.submitExceptionInformation.bind(this);
    this.setLTypeCasedetails = this.setLTypeCasedetails.bind(this);
    this.setDefaultValues = this.setDefaultValues.bind(this);
    this.getIsLoadingStatus = this.getIsLoadingStatus.bind(this);
    this.fetchTakeActionList = this.fetchTakeActionList.bind(this);
    this.getCreditTranDrawerData = this.getCreditTranDrawerData.bind(this);
    this.getQuestionireData = this.getQuestionireData.bind(this);
    this.updateExceptionCaseDetails = this.updateExceptionCaseDetails.bind(this);
    this.setCaseLandingData = this.setCaseLandingData.bind(this);
    this.onSubmitManuallyProcessAction = this.onSubmitManuallyProcessAction.bind(this);
    this.updateCaseDetails = this.updateCaseDetails.bind(this);
    this.getCaseDetails = this.getCaseDetails.bind(this);
  }

  /**
   * Custom method to replace char at position in string
   * @param {*} string 
   * @param {*} index 
   * @param {*} replace 
   */
  replaceAt(string, index, replace) {
    return string.substring(0, index) + replace + string.substring(index + 1);
  }

  /**
   * This method is responsible for submit and update op1 case details
   */
  submitExceptionInformation() {
    this.setState({
      isSubmitting: true,
      showExceptionCaseReviewBanner: false,
    })
    let queueId = (this.props.location.state !== undefined ? this.props.location.state.queueId : sessionStorage.getItem('queueid'));
    queueId == WEX_QUEUE_ID ? this.updateWexCaseData() : this.updateOp1CaseData();
  }

  updateWexCaseData() {
    let wexCaseDetails = this.setCaseDataForWex(this.state.op1Data);
    updateWexCaseData(wexCaseDetails).then((updateResponse) => {
      this.setState({
        isExceptionCaseUpdated: true,
        exceptionCaseNumber: updateResponse.data,
        isSubmitting: false,
      })
    }).catch(error => {
      console.log('Error Occured while updating Wex cases data', error);
      this.setState({
        isExceptionCaseError: true,
        isSubmitting: false,
        showExceptionCaseReviewBanner: false,
      })
    });
  }
  updateOp1CaseData() {
    let op1CaseDetail = this.setOpCaseDataForAmex(this.state.op1Data);
    if (this.state.op1Data.cardNumber && this.state.op1Data.cardNumber != "") {
      getToken(this.state.op1Data.cardNumber).then((response) => {
        op1CaseDetail.globalToken = response.data.GlobalToken;
        op1CaseDetail.merchantToken = response.data.MerchantToken;
        updateOp1CaseData(op1CaseDetail).then((updateResponse) => {
          this.setState({
            isExceptionCaseUpdated: true,
            exceptionCaseNumber: updateResponse.data,
            isSubmitting: false,
          })
        }).catch(error => {
          console.log('Error Occured while updating amex op1 cases data', error);
          this.setState({
            isExceptionCaseError: true,
            isSubmitting: false,
            showExceptionCaseReviewBanner: false,
          })
        });
      }).catch(error => {
        console.log('Error Occured while fetching tokens', error);
        this.setState({
          isExceptionCaseError: true,
          isSubmitting: false,
          showExceptionCaseReviewBanner: false,
        })
      });
    }
  }

  /**
   * Preparing data for submiting to update op1  case details
   * @param {*} op1CaseDetail 
   * @param {*} op1CaseData 
   */
  setOpCaseDataForAmex(op1CaseData) {
    var op1CaseDetail = {};
    let maskedCardNumber = op1CaseData.cardNumber;
    for (let i = 0; i < op1CaseData.cardNumber.length; i++) {
      if (i > 5 && i < op1CaseData.cardNumber.length - 4) {
        maskedCardNumber = this.replaceAt(maskedCardNumber, i, 'X');
      }
    }
    op1CaseDetail.cardNumber = maskedCardNumber;
    op1CaseDetail.sellerId = op1CaseData.sellerId;
    op1CaseDetail.disputeAmount = this.state.caseLandingData?.caseDetail?.disputeAmount ? parseFloat(this.state.caseLandingData.caseDetail.disputeAmount) : 0;
    op1CaseDetail.cardBrandMerchantNumber = op1CaseData.cardBrandMerchantNumber;
    op1CaseDetail.cardBrandCaseNumber = op1CaseData.cardBrandCaseNumber;
    op1CaseDetail.transactionAmount = op1CaseData.transactionAmount ? parseFloat(op1CaseData.transactionAmount) : 0;
    op1CaseDetail.disputeReasonCode = op1CaseData.disputeReasonCode;
    op1CaseDetail.acquirerReferenceNumber = op1CaseData.acquirerReferenceNumber;
    op1CaseDetail.memberMessageText = op1CaseData.memberMessageText;
    op1CaseDetail.disputeSourceId = this.state.caseLandingData.caseDetail.disputeSourceId;
    op1CaseDetail.caseStageId = this.state.caseLandingData.caseDetail.caseStageId;
    op1CaseDetail.caseReceivedDate = moment(op1CaseData.caseReceivedDate).format(this.state.exceptionQueueCaseDetail.dateFormatForApi);
    op1CaseDetail.transactionDate = moment(op1CaseData.transactionDate).format(this.state.exceptionQueueCaseDetail.dateFormatForApi);
    op1CaseDetail.dispositionActivityCode = this.state.caseLandingData.caseDetail.dispositionActivityCode;
    op1CaseDetail.dispositionActionCode = this.state.caseLandingData.caseDetail.dispositionActionCode;
    op1CaseDetail.disputeStageId = this.state.caseLandingData.caseDetail.disputeStageId;

    return op1CaseDetail;
  }

  setCaseDataForWex(wexCaseData) {
    var wexCaseDetail = {};
    wexCaseDetail.acquirerReferenceNumber = wexCaseData.acquirerReferenceNumber;
    wexCaseDetail.caseStageId = this.state.caseLandingData.caseDetail.caseStageId;
    wexCaseDetail.disputeSourceId = this.state.caseLandingData.caseDetail.disputeSourceId;
    wexCaseDetail.globalToken = '--';
    wexCaseDetail.memberMessageText = wexCaseData.notes;
    return wexCaseDetail;
  }



  setDisputeStageList(exceptionQueueCaseDetail, data) {
    let index = -1;
    let disputeIndex = -1;
    let disputeStages = [];
    exceptionQueueCaseDetail.dataColumns?.forEach((dataColumn) => {
      index++;
      if (dataColumn.columnKey == 'disputeStage') {
        disputeIndex = index;
        data.forEach((disputeStage) => {
          let stageObject = {
            text: disputeStage.stageName,
            value: disputeStage.stageId
          }
          disputeStages.push(stageObject);
        });
      }
    }
    );
    if (disputeIndex != -1) {
      exceptionQueueCaseDetail.dataColumns[disputeIndex].list = disputeStages;
    }
    return exceptionQueueCaseDetail;
  }

  onKeyPress(event) {
    const eventCode = event.code ? (event.code + "_" + event.ctrlKey + "_" + event.altKey) : event.key + "_" + event.ctrlKey + "_" + event.altKey;
    var selectedValue = "";
    switch (eventCode) {
      case KeyConstants.CTRL_LETTERN:
        selectedValue = this.validateSelectedValue(event, ActionConstants.__NOTIFY_REQ_DOCS_TITLE__);

        break;
      case KeyConstants.CTRL_LETTERA:
        selectedValue = this.validateSelectedValue(event, ActionConstants.__REQUEST_ADDON_INFO_TITLE__);

        break;
      case KeyConstants.CTRL_LETTERR:
        selectedValue = this.validateSelectedValue(event, ActionConstants.__RESPOND_TO_ISSUER_TITLE__);
        break;
      case KeyConstants.CTRL_LETTERU:
        selectedValue = this.validateSelectedValue(event, ActionConstants.__UNABLE_TO_DEFEND_TITLE__);
        break;
      case KeyConstants.CTRL_LETTERP:
        event.preventDefault();
        const selectedIndex = this.state.selectList.findIndex((item) => item.value === ActionConstants.__UNPEND_CASE_TITLE__);
        selectedValue = selectedIndex !== -1 ? ActionConstants.__UNPEND_CASE_TITLE__ : ActionConstants.__PEND_CASE_TITLE__;
        break;
      case KeyConstants.CTRL_LETTERW:
        selectedValue = this.validateSelectedValue(event, ActionConstants.__WRITE_OFF_GOODWILL_TITLE__);
        break;
      case KeyConstants.CTRL_LETTERC:
        selectedValue = this.validateSelectedValue(event, ActionConstants.__CLOSE_CASE_TITLE__);
        break;
      case KeyConstants.CTRL_LETTERT:
        selectedValue = this.validateSelectedValue(event, ActionConstants.__TRANSFER_CASE_TITLE__);
        break;
      case KeyConstants.CTRL_LETTERS:
        selectedValue = this.validateSelectedValue(event, ActionConstants.__PURSUE_CASE_TITLE__);
        break;
      case KeyConstants.CTRL_LETTERD:
        selectedValue = this.validateSelectedValue(event, ActionConstants.__UPLOAD_DOC_TITLE__);
        break;
      case KeyConstants.CTRL_LETTERJ:
        selectedValue = this.validateSelectedValue(event, ActionConstants.__CREATE_DOC_TITLE__);
        break;
      case KeyConstants.CTRL_LETTERE:
        selectedValue = this.validateSelectedValue(event, ActionConstants.__ADD_NOTES_TITLE__);
        break;
      case KeyConstants.CTRL_LETTERO:
        selectedValue = this.validateSelectedValue(event, ActionConstants.__UNABLE_TO_FULFIL_TITLE__);
        break;
      case KeyConstants.CTRL_LETTERQ:
        selectedValue = this.validateSelectedValue(event, ActionConstants.__UNPEND_CASE_TITLE__);
        break;
      case KeyConstants.CTRL_LETTERB:
        selectedValue = this.validateSelectedValue(event, ActionConstants.__RESPOND_TO_CARD_BRAND_ID_TITLE__);
        break;
      case KeyConstants.CTRL_LETTERX:
        document.getElementById('selectInput') && document.getElementById('selectInput').click();
        break;
      case KeyConstants.CTRL_LETTERM:
        selectedValue = this.validateSelectedValue(event, ActionConstants.__MANUALLY_PROCESSED_ID_TITLE__);
        break;
      case KeyConstants.CTRL_LETTERI:
        selectedValue = this.validateSelectedValue(event, ActionConstants.__REQUEST_ISSUER_DOC_TITLE__);
        break;

    }
    switch (event.key) {
      case KeyConstants.ESC_KEY:
        this.props.closeNotification;
    }

    selectedValue && this.onSelectionChange(selectedValue);

  }

  validateSelectedValue(event, title) {
    event.preventDefault();
    const selectedIndex = this.state.selectList.findIndex((item) => item.value === title);
    return selectedIndex !== -1 ? title : '';
  }

  /**
   * Reset case data on landing page on submit of take actions
   * @param {*} caseNumber 
   */
  resetCaseData(caseNumber) {
    if (caseNumber) {
      this.setState({
        isLoading: true
      });
      this.props.fetchCase(caseNumber, true);
    }
  }

  setCaseLandingData(currentCase) {
    const auth = loadState('auth');
    const userPermission = auth !== undefined && auth.user !== undefined ? auth.user.parsedPermissions : undefined;
    let ledgerAcquirerCode = currentCase.caseDetail.acquirerName;
    sessionStorage.setItem('caseAcquirerCode', ledgerAcquirerCode); //remove
    this.fetchTakeActionList(currentCase, userPermission);
    let caseStageId = currentCase.caseStageDetail.caseStageId;
    this.setState({
      disableTakeAction: NON_TAKE_ACTION_QUEUES.indexOf(currentCase.caseStageDetail.queueId) !== -1,
      isReadOnly: false,
      caseStageId,
      caseNumber: currentCase.caseDetail.caseNumber,
      caseLandingData: currentCase,
      isLoading: false,
      dataErr: false,
      isCaseFailedToLoad: false,
      isOp1OrWex: currentCase.isOp1OrWex
    });

    if (currentCase.caseStageDetail) {
      this.setLTypeCasedetails(currentCase.caseStageDetail);
    }
    this.props.addCurrentCaseNumber(currentCase.caseDetail.caseNumber);
  }
  getCaseStageDetail = (currentCase) => {
    if (currentCase.activeCaseStageDetail) {
      return currentCase.activeCaseStageDetail;
    } else if (currentCase.caseStageDetail) {
      return currentCase.caseStageDetail;
    } else {
      return null;
    }
  };

  fetchTakeActionList(currentCase, userPermission) {
    const caseStageDetail = this.getCaseStageDetail(currentCase);
    if (caseStageDetail !== null
      && caseStageDetail.pendIndicator
      && currentCase.caseDetail.acquirerName === 'MXP'
      && caseStageDetail.disputeStageId === 20) {
      this.setState({
        selectList: this.filterTakeActionList(getOutgoingArbitrationProsaList(userPermission), currentCase.takeActions, currentCase.isMerchantUiSLAExpired),
        actionPanelDetailList: getOutgoingArbitrationProsaListShow(),
        data: {
          caseStageId: caseStageDetail.caseStageId,
          caseUnpendBy: this.props.auth.user.userId,
          pendIndicator: false,
        },
        isTakeActionLoading: false,
      });
    } else if (caseStageDetail !== null && caseStageDetail.pendIndicator) {
      this.setState({
        selectList: this.filterTakeActionList(getUpdatedSelectionActionList(userPermission), currentCase.takeActions, currentCase.isMerchantUiSLAExpired),
        actionPanelDetailList: getUpdatedActionPanelDetailToShow(),
        data: {
          caseStageId: caseStageDetail.caseStageId,
          caseUnpendBy: this.props.auth.user.userId,
          pendIndicator: false,
        },
        isTakeActionLoading: false,
      });
    }
    else {
      this.setState({
        selectList: this.filterTakeActionList(getSelectionActionList(userPermission), currentCase.takeActions, currentCase.isMerchantUiSLAExpired),
        actionPanelDetailList: getActionPanelDetailToShow(),
        isTakeActionLoading: false,
      });
    }
  }


  /**
   * This method is used for filter the take action list
   */
  filterTakeActionList(allTakeActionList, takeActions, isMerchantUiSLAExpired) {
    let filteredTakeActions = [];
    allTakeActionList.forEach((action) => {
      const occuranceIndex = takeActions ? takeActions.findIndex((item) => action && item.takeActionCode === action.viewCode) : -1;
      filteredTakeActions = occuranceIndex !== -1 ? filteredTakeActions.concat(action) : filteredTakeActions;
    });
    let slaExpiredTakeAction = [];
    slaExpiredTakeAction = isMerchantUiSLAExpired ? filteredTakeActions.filter(ac => ac.viewCode != 'NRD' && ac.viewCode != 'RAI') : filteredTakeActions;
    return slaExpiredTakeAction;
  }

  /**
   * This method is responsible to update exception case data for op1, wex and ltype cases
   * @param {data to submit} data 
   */
  submitAndUpdateExceptionCases(data) {
    this.state.caseLandingData && setCaseStageId(this.state.caseLandingData.caseStageDetail.caseStageId);
    this.setState({
      op1Data: data
    })
    if (this.state.isOp1OrWex && !this.state.isSubmitting) {
      this.setState({
        showExceptionCaseReviewBanner: true,
      })
    } else if (!this.state.isSubmitting) {
      let lTypeData = {
        caseStageId: this.state.caseLandingData.caseStageDetail.caseStageId,
        disputeStageId: data.disputeStage.value,
        memberMessageText: data.notes,
      }
      this.setState({
        isSubmitting: true,
      });
      updateLTypeCaseData(lTypeData).then((response) => {
        this.setState({
          isLtype: false,
          isOp1OrWex: false,
          showLTypeSuccessBanner: true,
          isSubmitting: false,
          isLoading: true,
        })
      }).catch(error => {
        this.setState({
          isOp1OrWex: false,
          isExceptionCaseError: true,
          isSubmitting: false,
        })
        console.log("Error occured while submitting the ltype case");
      });

    }
  }

  goToPreviousPage() {
    if (this.props.history && this.props.history.length > 1) {
      this.props.history.goBack();
    } else {
      window.close();
    }
  }

  /**
   * This method is responsible to set default values for Op1case details forms
   */
  setDefaultValues() {
    const exceptionDefaultValues = {
      cardBrandMerchantNumber: this.state.cardBrandMerchantNumber,
      sellerId: trim(this.state.sellerId),
    };
    return exceptionDefaultValues;
  }
  onSelectionChange(option) {
    // Scroll to top when user selects any action from take action dropdown.

    setTimeout(() => {
      document?.getElementById("ActionPane")?.scrollIntoView({ behavior: "smooth", block: "start", inline: "start" });
    }, 70)

    let selectedActionId = 0;
    const selectedOption = this.state.selectList.find((item) => item.value === option);
    if (selectedOption != undefined) {
      for (let i = 0; i < this.state.selectList.length; i++) {
        if (selectedOption.text === this.state.selectList[i].text) {
          this.setState(prevState => ({
            // selectedActionId: prevState.selectList[i].id,
            submitActionOption: prevState.selectList[i].value,
          }));
          selectedActionId = this.state.selectList[i].id;
          break;
        }
      }
      if (selectedOption && selectedOption.text == EXIT_ACTION) {
        this.goToPreviousPage();
      }
      if (this.state.selectedActionId != selectedActionId) {
        const selectedActionPanelDetailItem = this.state.actionPanelDetailList.find((actionItem) => actionItem.id === selectedOption.id);
        this.setState({
          selectedActionPanelDetailItem,
          actionViewCode: selectedActionPanelDetailItem.viewCode,
          isIssuerActionSelected: this.isTakeActionItemSelected(selectedActionId),
          selectedActionId,
        });
        if (selectedActionId == ActionConstants.__UNPEND_CASE_ID__) {
          this.unpendCase();
        }
        if (selectedActionId == ActionConstants.__MANUALLY_PROCESSED_ID__) {
          this.setState({
            showManuallyProcessedConfirmationBanner: true
          })
        }
        if (selectedActionId == ActionConstants.__CREATE_DOCUMENT_ID__) {
          let baseQueueSelection = getUrlSearchParamValue(this.props.location.search, 'selectedBaseQueueItem');
          let subQueueSelection = getUrlSearchParamValue(this.props.location.search, 'subQueueSelection');
          window.open(`#/createdocument/${this.props.caseNumber}?selectedBaseQueueItem=${baseQueueSelection}&subQueueSelection=${subQueueSelection}`, "_self", 'scrollbars=1,toolbar=0,top=0,left=0').resizeTo(screen.width, screen.height);
          this.resetActionPane();
        }
        this.props.resetNestedFieldSelectorData();
      }
    }
  }

  isTakeActionItemSelected(selectedActionId) {
    return !!(selectedActionId == ActionConstants.__RESPOND_TO_CARD_BRAND_ID__ ||
      selectedActionId == ActionConstants.__UNABLETO_FULFILL_ID__ ||
      selectedActionId == ActionConstants.__TRANSFER_CASE_ID__ ||
      selectedActionId == ActionConstants.__RESPOND_TO_ISSUER_ID__ ||
      selectedActionId == ActionConstants.__UNABLE_TO_DEFEND_PURSUE_ID__ ||
      selectedActionId == ActionConstants.__WRITEOFF_GOODWILL_ID__ ||
      selectedActionId == ActionConstants.__REQUEST_ADDITIONAL_INFO_ID__ ||
      selectedActionId == ActionConstants.__CLOSE_CASE_ID__ ||
      selectedActionId == ActionConstants.__UPLOAD_DOCUMENT__ ||
      selectedActionId == ActionConstants.__CREATE_DOCUMENT_ID__ ||
      selectedActionId == ActionConstants.__NOTIFY_REQUEST_DOCS_ID__ ||
      selectedActionId == ActionConstants.__PURSUE_CASE_FILLING_ID__ ||
      selectedActionId == ActionConstants.__MANUALLY_PROCESSED_ID__ ||
      selectedActionId == ActionConstants.__REQUEST_ISSUER_DOCUMENT_ID__

    );
  }

  toggle = () => {
    this.setState(prevState => ({ isExpanded: !prevState.isExpanded }));
  }

  unpendCase() {
    updateActionPaneData(this.state.data, 'api/v1/disputecasedata/case/stage/pend').then((res) => {
      if (res.status.statusCode == 2005 && res.data === true) {
        this.setState({
          showBanner: true,
        });
        this.resetCaseData(this.state.caseLandingData.caseDetail.caseNumber);
      } else {
        this.setState({
          showRedBanner: true,
        });
      }
    }).catch((res) => {
      this.setState({
        showRedBanner: true,
      });
    });
  }

  resetActionPane() {
    this.setState(prevState => {
      return ({
        ...prevState,
        selectedActionPanelDetailItem: {},
        selectedItem: null,
        isDataUploaded: !prevState.isDataUploaded,
        selectedActionId: 0,
        showBanner: false,
        showRedBanner: false,
        showUnlinkSuccess: false,
        showUnlinkFailure: false,
        isIssuerActionSelected: false,
        actionViewCode: '',
        showExceptionCaseReviewBanner: false,
        showLTypeSuccessBanner: false,
        isExceptionCaseError: false,
        isExceptionCaseUpdated: false,
        isAmexError: false,
        isOp1CaseUpdated: false,
        getNextDisableFromAction: false,
        showManuallyProcessedConfirmationBanner: false,
        showManuallyProcessedSuccessBanner: false,
        showManuallyProcessedFailureBanner: false
      });
    });
  }

  onSubmitManuallyProcessAction() {
    this.setState({
      isLoading: true,
      showManuallyProcessedConfirmationBanner: false
    })
    const respondIssuerObject = {
      actionCode: 'MP',
      caseStageId: this.state.caseLandingData?.activeCaseStageDetail != null ? this.state.caseLandingData?.activeCaseStageDetail.caseStageId : this.state.caseLandingData.caseStageDetail.caseStageId,
      caseNumber: this.props.caseNumber,
      isAutoTakeAction: false,
      userId: this.props.auth.user.userId,
      caseStageActionCode: this.state.caseLandingData?.activeCaseStageDetail != null ? this.state.caseLandingData?.activeCaseStageDetail.takeActionCode : this.state.caseLandingData.caseStageDetail.takeActionCode,
      acquirerCode: this.state.caseLandingData.caseDetail.acquirerName
    };
    submitTakeActionResponse(respondIssuerObject, this.props.caseNumber)
      .then((res) => {
        if (res.status && (res.status.statusCode == 2000 || res.status.statusCode == 200)) {
          this.setState({
            showManuallyProcessedSuccessBanner: true,
            isLoading: false
          });
        }
      })
      .catch((res) => {
        this.setState({
          showManuallyProcessedFailureBanner: true,
          isLoading: false
        });
      });
  }

  setCaseStatus(status) {
    this.setState((prevState) => ({
      caseLandingData: {
        ...prevState.caseLandingData,
        caseStageDetail: {
          ...prevState.caseLandingData.caseStageDetail,
          statusName: status
        }
      },
      getNextDisableFromAction: false,
    }));
  }

  toggleDrawer = (flag, id) => {
    document.body.style.overflow = 'visible';
    this.props.setDrawerOpenFlag(flag);
    this.setState({
      drawerOpen: !this.state.drawerOpen,
      configId: id
    });
  }

  getCaseDrawerData(caseStageId, isCaseHeaderDrawer) {
    return getCaseData(caseStageId).then((apiResponse) => {
      this.setState({
        caseStageId: apiResponse.data[0].caseStageId,
        drawerData: apiResponse.data[0],
        isdataLoading: false,
        drawerdataErr: false,
        questionDrawer: false,
        caseHeaderDrawer: isCaseHeaderDrawer
      })
    }).catch((error) => {
      this.setState({ drawerdataErr: true, isdataLoading: false });
      console.log('Error Occured while fetching case drawer data', error);
    });
  }

  getAuthDrawerData(masterId, id, stageId) {
    return getAuthData(masterId).then((apiResponse) => {
      this.setState({
        caseStageId: stageId,
        drawerData: apiResponse.data[0],
        isdataLoading: false,
        drawerdataErr: false,
        questionDrawer: false,
      })
    }).catch((error) => {
      this.setState({ drawerdataErr: true, isdataLoading: false });
      console.log('Error Occured while fetching case drawer data', error);
    });
  }

  getTranDrawerData(masterId, id, stageId) {
    return getTranData(masterId).then((apiResponse) => {
      this.setState({
        caseStageId: stageId,
        drawerData: apiResponse.data[0],
        isdataLoading: false,
        drawerdataErr: false,
        questionDrawer: false,
      })
    }).catch((error) => {
      this.setState({ drawerdataErr: true, isdataLoading: false });
      console.log('Error Occured while fetching case drawer data', error);
    });
  }

  getCreditTranDrawerData(masterId, id, stageId) {
    return getCreditTranData(masterId).then((apiResponse) => {
      this.setState({
        caseStageId: stageId,
        drawerData: apiResponse.data[0],
        isdataLoading: false,
        drawerdataErr: false,
        questionDrawer: false,
      })
    }).catch((error) => {
      this.setState({ drawerdataErr: true, isdataLoading: false });
      console.log('Error Occured while fetching case drawer data', error);
    });
  }

  getSchemeDrawerData(caseStageId, isCaseHeaderDrawer) {
    return getCardBrandData(caseStageId)
      .then((apiResponse) => {
        this.setState({
          caseStageId: caseStageId,
          drawerData: getFormattedSchemeData(apiResponse.data),
          isdataLoading: false,
          drawerdataErr: false,
          questionDrawer: false,
          caseHeaderDrawer: isCaseHeaderDrawer
        })
      }).catch((error) => {
        this.setState({ drawerdataErr: true, isdataLoading: false });
        console.log('Error Occured while fetching case drawer data', error);
      });
  }

  getQuestionireData(caseStageId) {
    return getQuestionnaireDetails(caseStageId).then((apiResponse) => {
      this.setState({
        caseStageId: caseStageId,
        questionireData: null != apiResponse.data ? apiResponse.data : {},
        isdataLoading: false,
        drawerdataErr: false,
        questionDrawer: true,
      })
    }).catch((error) => {
      this.setState({ drawerdataErr: true, isdataLoading: false, questionDrawer: true });
      console.log('Error Occured while fetching questionire drawer data', error);
    });
  }

  getApiDrawerData(caseStageId, index, stageId, isCaseHeaderDrawer) {
    switch (index) {
      case 1:
        this.getCaseDrawerData(caseStageId, isCaseHeaderDrawer);
        break;
      case 2:
        this.getSchemeDrawerData(caseStageId, isCaseHeaderDrawer);
        break;
      case 3:
        this.getAuthDrawerData(caseStageId, index, stageId);
        break;
      case 4:
        this.getTranDrawerData(caseStageId, index, stageId);
        break;
      case 5:
        this.getCreditTranDrawerData(caseStageId, index, stageId);
        break;
      case 6:
        this.getQuestionireData(caseStageId);
        break;
      case 7:
        this.getCreditTranDrawerData(caseStageId, index, stageId);
        break;
      default:
        return;
    }
    this.setState({
      isdataLoading: true,
    })
  }

  callUnlinkBanner = (result) => {
    this.setState({
      [result]: true,
    });
  }

  showUnlinkSuccessBanner = () => {
    return (
      <div>
      <ImagePortal>
        <ResponseBanner
          titleStyle={{ color: 'light-green' }}
          descriptionStyle={{ color: 'grey' }}
          valueStyle={{ color: 'black' }}
          title="Image(s) Unlinked Successfully"
          description=""
          type="success"
          onClose={this.resetActionPane}
          cancelOnly
          cancelButtonText="CLOSE"
          primaryButtonActionValue=""
        />
        </ImagePortal>
      </div>
    );
  }

  showUnpendSuccessBanner() {
    return (
      <div>
        <ImagePortal>
        <ResponseBanner
          titleStyle={{ color: 'light-green' }}
          descriptionStyle={{ color: 'grey' }}
          valueStyle={{ color: 'black' }}
          title="Case Unpended Successfully"
          description=""
          type="success"
          onClose={this.resetActionPane}
          cancelOnly
          cancelButtonText="CLOSE"
          primaryButtonActionValue=""
        />
        </ImagePortal>
      </div>
    );
  }
  showExceptionCaseSuccessBanner() {
    return (
      <div>
        <ImagePortal>
        <ResponseBanner
          titleStyle={{ color: 'light-green' }}
          descriptionStyle={{ color: 'grey' }}
          valueStyle={{ color: 'black' }}
          title={this.state.exceptionCaseNumber}
          description="Case has been created Successfully"
          type="success"
          onClose={this.resetActionPane}
          cancelOnly
          cancelButtonText="CLOSE"
          primaryButtonActionValue=""
        />
        </ImagePortal>
      </div>
    );
  }

  showExceptionCaseReviewBanner() {
    return (
      <div>
        <ImagePortal>
        <ResponseBanner
          titleStyle={{ color: 'light-green' }}
          descriptionStyle={{ color: 'grey' }}
          valueStyle={{ color: 'black' }}
          title="Please Review"
          description="Please review the information provided in the fields below and confirm that it is correct before submitting."
          onClose={this.resetActionPane}
          type="info"
          primaryButtonText="SUBMIT INFORMATION"
          cancelButtonText="CONTINUE EDITING"
          isSecondaryButton
          isSecondaryButtonActive=""
          secondaryButtonAction=""
          primaryButtonAction={this.submitExceptionInformation}
        />
        </ImagePortal>
      </div>
    );
  }
  showManuallyProcessedConfirmationBanner() {
    return (
      <div>
        <ImagePortal>
        <ResponseBanner
          titleStyle={{ color: 'light-green' }}
          descriptionStyle={{ color: 'grey' }}
          valueStyle={{ color: 'black' }}
          title={counterpart('globalTranslate.takeAction.titleManuallyProcessedConfirmation')}
          description={counterpart('globalTranslate.takeAction.manuallyProcessedConfirmationMessage')}
          onClose={this.resetActionPane}
          type="warning"
          primaryButtonText={counterpart('globalTranslate.takeAction.manuallyProcessedConfirmationButton')}
          cancelButtonText={counterpart('globalTranslate.takeAction.cancel')}
          isSecondaryButton
          isSecondaryButtonActive=""
          secondaryButtonAction=""
          primaryButtonAction={this.onSubmitManuallyProcessAction}
        />
        </ImagePortal>
      </div>
    );
  }
  showManuallyProcessedSuccessBanner() {
    return (
      <div>
        <ImagePortal>
        <ResponseBanner
          titleStyle={{ color: 'light-green' }}
          descriptionStyle={{ color: 'grey' }}
          valueStyle={{ color: 'black' }}
          title={counterpart('globalTranslate.takeAction.success')}
          description={counterpart('globalTranslate.takeAction.manuallyProcessedSuccessMessage')}
          type="success"
          onClose={reloadPage}
          cancelOnly
          cancelButtonText={counterpart('globalTranslate.takeAction.dismiss')}
          primaryButtonActionValue=""
        />
        </ImagePortal>
      </div>
    );
  }
  showManuallyProcessedFailureBanner() {
    return (
      <div>
        <ImagePortal>
        <ResponseBanner
          titleStyle={{ color: 'light-green' }}
          descriptionStyle={{ color: 'grey' }}
          valueStyle={{ color: 'black' }}
          title={counterpart('globalTranslate.takeAction.errorOccurred')}
          description={counterpart('globalTranslate.takeAction.manuallyProcessedFailureMessage')}
          type="danger"
          onClose={this.resetActionPane}
          cancelButtonText={counterpart('globalTranslate.takeAction.dismiss')}
          primaryButtonActionValue={this.props.caseNumber}
          primaryButtonText={counterpart('globalTranslate.takeAction.okayDoSomething')}
          primaryButtonAction={this.resetActionPane}
        />
        </ImagePortal>
      </div>
    );
  }
  showUnpendErrorBanner() {
    return (
      <div>
        <ImagePortal>
        <ResponseBanner
          titleStyle={{ color: 'light-green' }}
          descriptionStyle={{ color: 'grey' }}
          valueStyle={{ color: 'black' }}
          title="System Error:"
          description="Unable to unpend case."
          type="danger"
          onClose={this.resetActionPane}
          cancelOnly
          cancelButtonText="DISMISS"
          primaryButtonActionValue=""
        />
        </ImagePortal>
      </div>
    );
  }
  showAmexLTypeSuccessBanner() {
    return (
      <div>
        <ImagePortal>
        <ResponseBanner
          titleStyle={{ color: 'light-green' }}
          descriptionStyle={{ color: 'grey' }}
          valueStyle={{ color: 'black' }}
          title="Success"
          description="Case stage updated succesfully"
          type="success"
          onClose={reloadPage}
          cancelOnly
          cancelButtonText="DISMISS"
          primaryButtonActionValue=""
        />
        </ImagePortal>
      </div>
    );
  }
  showExceptionCaseErrorBanner() {
    return (
      <div>
        <ImagePortal>
        <ResponseBanner
          titleStyle={{ color: 'light-green' }}
          descriptionStyle={{ color: 'grey' }}
          valueStyle={{ color: 'black' }}
          title="System Error:"
          description="Unable to update Case details."
          type="danger"
          onClose={this.resetActionPane}
          cancelOnly
          cancelButtonText="DISMISS"
          primaryButtonActionValue=""
        />
        </ImagePortal>
      </div>
    );
  }

  showUnlinkErrorBanner = () => {
    return (
      <div>
        <ImagePortal>
        <ResponseBanner
          titleStyle={{ color: 'light-green' }}
          descriptionStyle={{ color: 'grey' }}
          valueStyle={{ color: 'black' }}
          title="Error:"
          description="Unable to unlink image(s)."
          type="danger"
          onClose={this.resetActionPane}
          cancelOnly
          cancelButtonText="DISMISS"
          primaryButtonActionValue=""
        />
        </ImagePortal>
      </div>
    );
  }
  onReadOnly(notificationContent) {
    const notificationMessageSuccess = {
      type: 'info',
      placement: 'topRight',
      messageWidth: 250,
      byDefault: true,
      duration: 10,
      content: notificationContent,
    };

    return openNotificationToast(notificationMessageSuccess);

  }
  renderResponseBanner() {
    return (
      <div>
        <ImagePortal>
        <ResponseBanner
          titleStyle={{ color: 'light-green' }}
          descriptionStyle={{ color: 'grey' }}
          valueStyle={{ color: 'black' }}
          title={this.props.banner.title}
          description={this.props.banner.description}
          type={this.props.banner.type}
          onClose={this.props.banner.closeNotification}
          primaryButtonText={this.props.banner.primaryButtonText}
          cancelButtonText={this.props.banner.cancelButtonText}
          secondaryButtonAction={this.props.banner.secondaryButtonAction}
          primaryButtonAction={this.props.banner.primaryButtonAction}
          primaryButtonActionValue={this.props.banner.primaryButtonActionValue}
          cancelOnly={this.props.banner.cancelOnly}
          isPrimarSecondaryButtonCombo={true}
        />
        </ImagePortal>
      </div>

    );
  }

  gotoExtraCaseDetailsPage(id) {
    window.open(`#/casedetails/${this.props.caseNumber}?key=${id}`, '_blank').resizeTo(screen.width, screen.height);
  }

  gotoNewTabPage(id) {
    window.open(`#/timelinedetails/${this.state.caseStageId}?key=${id}&caseNumber=${this.props.caseNumber}`, '_blank').resizeTo(screen.width, screen.height);
  }

  toggleBookMarkIcon() {
    if (this.state.isBookMarked) {
      return postBookMarkCase(this.state.caseLandingData.caseStageDetail.caseStageId)
        .then(() => {
          this.setState({
            isBookMarked: false,
          });
        })
        .catch((error) => {

          console.log('Error Occured while Bookmarking the case', error);
        });
    }
    else {
      return undoBookMarkCase(this.state.caseLandingData.caseStageDetail.caseStageId)
        .then(() => {
          this.setState({
            isBookMarked: true,
          });
        })
        .catch((error) => {
          console.log('Error Occured while un-bookmarking the case', error);
        });
    }

  }

  removeCurrentLockedCase(e) {
    e.preventDefault();
    this.props.unloadCaseInfo(this.state.caseLandingData.caseDetail.caseNumber);
    this.props.unloadCaseAsActive(this.state.caseLandingData.caseDetail.caseNumber, this.state.caseLandingData.caseStageDetail.caseStageId);
    //e.returnValue = '';
  }

  performTakeAction() {
    const progressiveStages = [4, 5, 8, 9, 10, 11, 12, 13, 14, 19, 20];
    const stage = this.state.caseLandingData.caseStageDetail.disputeStageId && progressiveStages.indexOf(this.state.caseLandingData.caseStageDetail.disputeStageId) !== -1;
    if (this.props.auth.user.parsedPermissions.case.actionRetrieval === true && this.state.caseLandingData.caseStageDetail.disputeStageId === 1) {
      return (
        <SelectInput
          dataList={this.state.selectList}
          selectClass={{
            color: `${COLORS.oneGp.globalBlue}`,
            marginLeft: '-60px',
            width: '265px',
            fontWeight: 700,
            fontSize: 14,
          }}
          handleSelection={this.onSelectionChange}
          id={"selectInput"}
          promptText="Take Action <b style=color:#595959>CTRL+ALT+X</b>"
          selectedItem={this.state.selectedItem}
          wrapperClass="select-menu__form reports"
          promptOnly
          isAppSelection
        />
      )
    }
    if (this.props.auth.user.parsedPermissions.case.actionChargeback === true && (this.state.caseLandingData.caseStageDetail.disputeStageId === 2
      || this.state.caseLandingData.caseStageDetail.disputeStageId === 24)) {
      return (
        <SelectInput
          dataList={this.state.selectList}
          selectClass={{
            color: `${COLORS.oneGp.globalBlue}`,
            marginLeft: '-60px',
            width: '265px',
            fontWeight: 700,
            fontSize: 14,
          }}
          handleSelection={this.onSelectionChange}
          id={"selectInput"}
          promptText="Take Action <b style=color:#595959>CTRL+ALT+X</b>"
          selectedItem={this.state.selectedItem}
          wrapperClass="select-menu__form reports"
          promptOnly
          isAppSelection
        />
      )
    }
    if (this.props.auth.user.parsedPermissions.case.actionProgressive === true && stage) {
      return (
        <SelectInput
          dataList={this.state.selectList}
          selectClass={{
            color: `${COLORS.oneGp.globalBlue}`,
            marginLeft: '-60px',
            width: '265px',
            fontWeight: 700,
            fontSize: 14,
          }}
          handleSelection={this.onSelectionChange}
          id={"selectInput"}
          promptText="Take Action <b style=color:#595959>CTRL+ALT+X</b>"
          selectedItem={this.state.selectedItem}
          wrapperClass="select-menu__form reports"
          promptOnly
          isAppSelection
        />
      )
    }
    if (this.props.auth.user.parsedPermissions.case.actionRejected === true && this.state.caseLandingData.caseStageDetail.caseRejectStatus) {
      return (
        <SelectInput
          dataList={this.state.selectList}
          selectClass={{
            color: `${COLORS.oneGp.globalBlue}`,
            marginLeft: '-60px',
            width: '265px',
            fontWeight: 700,
            fontSize: 14,
          }}
          handleSelection={this.onSelectionChange}
          id={"selectInput"}
          promptText="Take Action <b style=color:#595959>CTRL+ALT+X</b>"
          selectedItem={this.state.selectedItem}
          wrapperClass="select-menu__form reports"
          promptOnly
          isAppSelection
        />
      )
    }
  }

  getIsLoadingStatus() {
    const { isLoading, isMerchantDetailsLoading, isBankDetailsLoading, isTakeActionLoading,
      isActionPagesLoading, isAccountDataLoading, isTransactionDetailsLoading, isAuthDetailLoading } = this.state;
    return (isLoading || isMerchantDetailsLoading || isBankDetailsLoading || isTakeActionLoading ||
      isActionPagesLoading || isAccountDataLoading || isTransactionDetailsLoading || isAuthDetailLoading);
  }

  getSubmitActionStatus = (statusFlag) => {
    this.setState({
      getNextDisableFromAction: statusFlag
    })
  }

  exportFile(fileName, fileType, isAllColumns) {
    const sortObj = this.state.sortArr.map(obj => {
      return {
        fieldId: getRelatedCasesFilterList().elementIDs.find(data => data.columnKey == obj.key) !== undefined && getRelatedCasesFilterList().elementIDs.find(data => data.columnKey == obj.key).elementId,
        orderByProperty: (obj.order) ? 'ASC' : 'DESC',
      }
    })

    let acquirerList = getAcquirerAccessList();
    let queueExportData = {
      fileType: fileType,
      isAllColumns: isAllColumns,
      pageId: getRelatedCasesFilterList().pageId,
      searchFilterInput: {
        size: this.state.totalRecords,
        sortingElement: sortObj,
        acquirerCode: acquirerList,
        globalToken: this.state.caseLandingData?.caseDetail.globalToken,
        merchantNumber: this.state.caseLandingData?.merchantDetail.merchantNumber,
      }
    }
    this.setState({ exporting: true });
    exportRelatedCasesData(queueExportData).then((response) => {
      downloadFile(fileName, fileType, response);
      this.setState({ exporting: false });
    })
      .catch((error) => {
        this.setState({ exporting: false });
        console.log('Error Occured while exporting the case', error);
      });
  }

  rowActionClick = (selectedKeyIndex, key) => {
    if (key === 'OPEN_CASE') {
      this.gotoCaseLandingPage(selectedKeyIndex);
    }
    if (key === "OPEN_CASE_IN_TAB") {
      gotoNewTabCaseLandingPage(this.state.caseData[selectedKeyIndex].caseNumber);
    }
  }

  gotoCaseLandingPage = (selectedKeyIndex) => {
    this.onCloseButtonClick();
    this.props.history.push({
      state: {
        data: this.state.caseData[selectedKeyIndex],
        prevPath: this.props.location.pathname,
      },
      pathname: '/caselanding/' + `${this.state.caseData[selectedKeyIndex].caseNumber}`,
    });
  }



  saveCurrentlyVisibleColumns = (columns) => {

    this.setState({
      dataColumns: columns,
    });

    const activeDataColumns = [];
    columns.forEach((column) => {
      if (column.displayType !== 'ICON') {
        const activeColumn = {
          columnId: column.columnId,
          displayOrder: column.displayOrder,
        };
        activeDataColumns.push(activeColumn);
      }
    });

    this.postActiveFilters(activeDataColumns);
  }

  postActiveFilters = (columns) => {
    return postActiveFilters(getRelatedCasesFilterList().pageId, columns)
      .then(() => {
        this.props.fetchDataColumns(getRelatedCasesFilterList().pageId);
        this.setState({
          isrelatedSearchDataError: false,
          isrelatedSearchLoading: false,
        });
      })
      .catch((error) => {
        this.setState({ caseDataErr: true, isLoading: false });
        console.log('Error Occured while saving active data columns', error);
      });
  }

  toggleFileExport = () => {
    this.setState({ filterExportIsVisible: !this.state.filterExportIsVisible });
  }

  toggleThisAccordion = () => {
    this.setState({ isAccordionOpen: !this.state.isAccordionOpen });
  }

  exportAction = (fileObject) => {
    this.toggleFileExport();
    let isAllColumns = fileObject.exportType.value === 'all-columns' ? true : false;
    let fileType = fileObject.fileType.value;
    let fileName = fileObject.fileName;
    this.state.totalRecords > 25000 ?
      this.setState({
        setSize: true,
      })
      :
      this.exportFile(fileName, fileType, isAllColumns);
  }

  checkSize() {
    this.props.setNotification([{
      title: `Error Occured`,
      descriptionStyle: "color: 'grey'",
      description: 'Your export request has exceeded the limitation of 25,000 rows.  Please apply additional filters to reduce of number rows.',
      type: 'danger',
      noActions: true,
      cancelOnly: true,
      closeNotification: () => this.props.closeNotification(),
    }]);
    this.setState({
      setSize: false,
    })
  }

  handleSort = (key, sortArr) => {
    this.setState({
      currentPage: 1,
      agLoader: true,
      isrelatedSearchLoading: true,
      isrelatedSearchDataError: false,
      sortArr,
    },
      () => {
        this.getRelatedCaseSearchData();
      }
    );
  }

  getRelatedCaseSearchData = (args) => {
    const mainContent = document.getElementsByClassName('main-content');
    mainContent[0].scrollTop = 0;

    this.props.setSearchOpenFlag(true);
    this.setState({
      isrelatedSearchLoading: true,
    })
    let size = 5;

    const auth = loadState('auth');
    const userPermission = auth.user.parsedPermissions;
    const queueMetaDataClone = { ...queueMetaData(userPermission, null, true) };
    queueMetaDataClone.dataColumns = [...addIconsToGDTableHeadersList(this.props.dataColumns, null)];

    const tempSortObj = this.state.sortArr.map(obj => {
      return {
        key: getRelatedCasesFilterList().elementIDs.find(data => data.columnKey == obj.key) !== undefined && getRelatedCasesFilterList().elementIDs.find(data => data.columnKey == obj.key).elementId,
        order: obj.order,
      }
    })

    return getRelatedCaseSearchData({
      globalToken: this.state.caseLandingData?.caseDetail.globalToken,
      merchantNumber: this.state.caseLandingData?.caseStageDetail.merchantNumber,
      acquirerCode: getAcquirerAccessList(),
      pageNumber: args?.pageNumber ? args?.pageNumber : 0,
      size: args?.size ? args?.size : size,
      sortArr: tempSortObj,
    })
      .then((apiResponse) => {
        const formattedData = apiResponse.data.content;
        this.setState({
          queueMetaData: queueMetaDataClone,
          caseData: formattedData,
          totalRecords: apiResponse.data.totalElements,
          totalPages: apiResponse.data.totalPages,
          currentPage: apiResponse.data.number + 1,
          recordsShown: args?.size ? args?.size : size,
          isNextPage: !apiResponse.data.last,
          isrelatedSearchLoading: false,
          isrelatedSearchLoaded: true,
          isrelatedSearchDataError: false,
          tableName: getRelatedCasesFilterList().headerName,
          agLoader: false,
          userPermission,
          statusErrorCode: apiResponse.status.statusCode,
          isGridOpen: true
        }
        );
      })
      .catch((error) => {
        this.setState({ isrelatedSearchLoading: false, isrelatedSearchDataError: true, statusErrorCode: error.response.status });
        console.log('Error Occured while fetching data for related search', error);
      });
  }

  pageHandler = (newPage, newPerPage) => {
    this.setState({
      isrelatedSearchLoading: true,
      isrelatedSearchDataError: false,
    },
      () => {
        const pageSize = newPerPage === undefined ? this.state.recordsShown : newPerPage;
        if (newPage) {
          this.getRelatedCaseSearchData({ pageNumber: newPage - 1, size: pageSize });
        }
      }
    );
  }

  onRowClick = (event, sequenceKey) => {
    if ((!event.target.id &&
      !event.target.classList.contains('gd-row-actions') &&
      !event.target.classList.contains('dropdown-menu-trigger')) ||
      event.target.parentNode.classList.contains('primary')) {
      alert(`Row #${sequenceKey} clicked.`);
    }
  }

  onCloseButtonClick = () => {
    this.setState({
      isGridOpen: false,
      caseData: [],
      isrelatedSearchLoaded: false
    });
    this.props.setSearchOpenFlag(false);
    if (this.props.dataTransactionGridStatus === true) {
      this.props.setDataSearchTrasactionGridProp(true, false, true);
    } else {
      this.props.setDataSearchTrasactionGridProp(false, true, false);
    }
  }

  getRelatedTransactionSearchData = () => {
    const mainContent = document.getElementsByClassName('main-content');
    mainContent[0].scrollTop = 0;

    this.props.toggleAppSearchPanelAction(true);
    this.props.setRelatedGridLoadedAction(false);
    this.props.setSearchOpenFlag(true);
    this.props.setSearchType("relatedTransactionSearch"); // coming from main.js as props
    this.props.setMerchantDetailsAction({
      globalToken: this.state.caseLandingData?.caseDetail.globalToken,
      merchantNumber: this.state.caseLandingData?.merchantDetail.merchantNumber,
      merchantName: this.state.caseLandingData.merchantDetail.dbaName,
      cardNumber: this.state.caseLandingData.caseStageDetail.maskedCardNumber
    });
  }

  getLatestStageId = (data) => {
    return data.map(i => i.caseStageId).sort((a, b) => b - a)[0];
  }

  relatedSearchTopMargin = () => {
    if (this.state.caseLandingData.caseStageDetail.disputeStageName !== UNIDENTIFIED_STAGE) {
      if (this.state.isrelatedSearchLoaded === true &&
        this.props.isRelatedTransactionGridOpen === false &&
        (!this.props.dataTransactionGridStatus || this.props.dataTransactionGridStatus === false)) {
        return 130
      } else if (this.state.isrelatedSearchLoaded === false && this.props.isRelatedTransactionGridOpen === true) {
        return 0
      } else if (this.state.isrelatedSearchLoaded === true &&
        this.props.isRelatedTransactionGridOpen === false &&
        this.props.dataTransactionGridStatus &&
        this.props.dataTransactionGridStatus === true) {
        return 10
      }
    } else {
      if (this.props.dataTransactionGridStatus === true &&
        this.state.isrelatedSearchLoaded === true) {
        return 10
      }
      return 70
    }

  }

  genericOverviewContainerClass = () => {
    /*
      this.state.isrelatedSearchLoaded is "Related Search Dispute Overview"
      this.props.isRelatedTransactionGridOpen is "Related Transaction Grid"
      this.props.dataTransactionGridStatus is "Data Search Related Transaction"
      this.state.amexDisputeReasonCode is "op1 cases"
    */

    return (!this.props.isRelatedTransactionGridOpen &&
      !this.state.isrelatedSearchLoaded &&
      !this.props.dataTransactionGridStatus &&
      (!this.state.actionViewCode || this.state.actionViewCode === '') &&
      !this.state.amexDisputeReasonCode)
  }

  overviewContainer = () => {
    /*
      this.state.isrelatedSearchLoaded is "Related Search Dispute Overview"
      this.props.isRelatedTransactionGridOpen is "Related Transaction Grid"
      this.props.dataTransactionGridStatus is "Data Search Related Transaction"
      this.state.amexDisputeReasonCode is "op1 cases"
    */
    if (this.genericOverviewContainerClass()) {
      return (this.state.caseLandingData?.activeCaseStageDetail != null) ? 'overview-container__active-case-warning' : 'overview-container'
    } else {
      if (!this.state.actionViewCode || this.state.actionViewCode === '') {
        if (this.state.caseLandingData?.caseStageDetail?.disputeStageName === UNIDENTIFIED_STAGE) {
          return 'overview-container__unidentified'
        } else if ((this.props.isRelatedTransactionGridOpen === false &&
          this.state.isrelatedSearchLoaded === true)
          ||
          (this.state.isrelatedSearchLoaded === false &&
            this.props.isRelatedTransactionGridOpen === true)
          ||
          ((this.props.dataTransactionGridStatus && this.props.dataTransactionGridStatus === true)
            &&
            this.props.isRelatedTransactionGridOpen === false && this.state.isrelatedSearchLoaded === false)) {
          return 'overview-container__related-cases'
        } else {
          return 'overview-container__search-type'
        }
      } else {
        return 'overview-container__search-type-actionViewCode'
      }
    }
  }

  mainContentWrapper = () => {
    if (this.props.isRelatedTransactionGridOpen === false &&
      this.state.isrelatedSearchLoaded === false &&
      (!this.props.dataTransactionGridStatus || this.props.dataTransactionGridStatus === false) &&
      !this.state.amexDisputeReasonCode) {
      return 'main-content--wrapper'
    } else {
      if (this.state.caseLandingData?.caseStageDetail?.disputeStageName === UNIDENTIFIED_STAGE) {
        'main-content--wrapper--unidentified'
      } else if (this.props.isRelatedTransactionGridOpen === true ||
        this.state.isrelatedSearchLoaded === true ||
        (this.props.dataTransactionGridStatus &&
          this.props.dataTransactionGridStatus === true) &&
        (this.state.actionViewCode && this.state.actionViewCode !== '')) {
        return 'main-content--wrapper--search-type--actionViewCode'
      } else if (this.state.amexDisputeReasonCode === OP1_REASON_CODE) {
        return this.props.isSearchActive ? 'main-content--wrapper--search-type--op1-data-search' : 'main-content--wrapper--search-type--op1'
      } else {
        return 'main-content--wrapper--search-type'
      }
    }
  }

  mainHeaderClass = () => {
    /*
      this.state.isrelatedSearchLoaded is "Related Search Dispute Overview"
      this.state.caseLandingData.caseStageDetail_disputeStageName is "Name of dispute stage"
    */

    if (this.props.isSearchActive === true && this.state.isrelatedSearchLoaded === false) {
      if (this.state.caseLandingData.caseStageDetail?.disputeStageName === UNIDENTIFIED_STAGE) {
        return 'main-content--header__unidentified-header';
      } else if (this.state.amexDisputeReasonCode === OP1_REASON_CODE) {
        return 'main-content--header__op1-header'
      } else {
        return 'main-content--header__transaction-header';
      }
    } else {
      return this.caseHeader('main-content--header')
    }
  }

  caseHeader = (caseHeaderClass) => {
    /*
      this.state.isrelatedSearchLoaded is "Related Search Dispute Overview"
      this.state.caseLandingData.caseStageDetail_disputeStageName is "Name of dispute stage"
    */

    if (this.state.caseLandingData?.caseStageDetail?.disputeStageName === UNIDENTIFIED_STAGE) {
      return caseHeaderClass !== CASE_HEADER_CONTAINER ? `${caseHeaderClass}__unidentified-header` : caseHeaderClass;
    } else {
      if (this.state.amexDisputeReasonCode && this.state.amexDisputeReasonCode === OP1_REASON_CODE) {
        return caseHeaderClass !== CASE_HEADER_CONTAINER ? `${caseHeaderClass}__op1-header` : caseHeaderClass;
      } else if (caseHeaderClass === CASE_HEADER_INNER) {
        return this.props.isSearchActive ? 'case-header--active-search' : 'case-header'
      } else if (caseHeaderClass === CASE_HEADER_CONTAINER) {
        return ''
      } else if (caseHeaderClass === MAIN_CONTENT_HEADER) {
        return 'main-content--header reports-container--header';
      }
    }
  }

  getFetchCaseLoader = () => {
    this.setState({
      isLoading: true
    })
  }

  render() {
    let getNextDisable = this.getIsLoadingStatus() || this.state.getNextDisableFromAction;
    const mainContentClass = 'case-landing';

    window.document.title = this.props.caseNumber !== undefined ? this.props.caseNumber : 'Case Landing';
    const data = this.state.isExpanded ? getOverviewData(this.state.isOp1OrWex) : getOverviewData(this.state.isOp1OrWex).filter((element) => { return element.defaultIsVisible === true; });
    let report = Object.assign({}, this.state.queueMetaData);
    report.dataColumns = Object.assign([], addIconsToGDTableHeadersList(this.props.dataColumns, null));
    return (
      <div>
        {this.props.notification.internalCaseShow && this.renderResponseBanner()}
        {
          (this.state.dataErr || this.state.isCaseFailedToLoad || this.state.tabLimitExceed) && !this.state.isLoading && (
            <EmptyState
              translations={{ emptyStateHeading: this.state.emptyStateHeading, emptyStateDescription: this.state.emptyStateDescription }}
            />
          )
        }
        {this.state.setSize == true &&
          this.checkSize()
        }
        {this.state.showBanner && this.showUnpendSuccessBanner()}
        {this.state.showLTypeSuccessBanner && this.showAmexLTypeSuccessBanner()}
        {this.state.showExceptionCaseReviewBanner && this.showExceptionCaseReviewBanner()}
        {this.state.showRedBanner && this.showUnpendErrorBanner()}
        {this.state.showUnlinkSuccess && this.showUnlinkSuccessBanner()}
        {this.state.showUnlinkFailure && this.showUnlinkErrorBanner()}
        {this.state.isExceptionCaseUpdated && this.showExceptionCaseSuccessBanner()}
        {this.state.isExceptionCaseError && this.showExceptionCaseErrorBanner()}
        {this.state.showManuallyProcessedConfirmationBanner && this.showManuallyProcessedConfirmationBanner()}
        {this.state.showManuallyProcessedSuccessBanner && this.showManuallyProcessedSuccessBanner()}
        {this.state.showManuallyProcessedFailureBanner && this.showManuallyProcessedFailureBanner()}
        {this.state.isLoading && <div className="ball-sync-loader loader" style={{ height: 200 }}><BVLoader20 /></div>}

        {
          this.state.isrelatedSearchLoading && (
            <div className="ball-sync-loader loader" style={{ backgroundColor: 'white' }}>
              <BVLoader20 />
            </div>
          )
        }

        {!this.state.isrelatedSearchLoading && !this.state.isrelatedSearchDataError && this.state.isGridOpen && this.state.caseData?.length > 0 &&
          <div style={{ marginTop: this.relatedSearchTopMargin() }}
            id="relatedSearchGrid" ref={((ref) => (this.gdTable = ref))}>
            <GridAccordion
              isrelatedSearchLoaded={this.state.isrelatedSearchLoaded}
              isOpen={this.state.isAccordionOpen}
              toggleAccordion={this.toggleThisAccordion}
              rowHeight={43}
              isAgGrid={true}
              isGridCompact={true}
              isCellborder={true}
              merchantDetail={{
                merchantName: this.state.caseLandingData.merchantDetail?.dbaName || '',
                merchantNumber: this.state.caseLandingData.caseStageDetail.merchantNumber,
                cardNumber: this.state.caseLandingData.caseStageDetail.maskedCardNumber
              }}
              className="queueLandingTable"
              report={report}
              tableName={this.state.tableName}
              data={this.state.caseData}
              dateFormat={queueMetaData().dateFormat}
              totalPages={this.state.totalPages}
              totalRecords={this.state.totalRecords}
              recordsCountText={{ showingRecords: 'Showing records', preposition: 'of' }}
              currentPage={this.state.currentPage}
              recordsShown={this.state.recordsShown}
              sort={this.state.sortArr}
              handleSort={this.handleSort}
              pageHandler={this.pageHandler}
              translations={getTranslations()}
              filterText={this.state.filterText}
              onRowClick={this.onRowClick}
              isPagable={this.state.queueMetaData.isPagable}
              isNextPage={this.state.isNextPage}
              exporting={this.state.exporting}
              exportAction={this.exportAction}
              filterExportIsVisible={this.state.filterExportIsVisible}
              toggleFileExport={this.toggleFileExport}
              actionButtonText="Actions"
              rowActionClick={this.rowActionClick}
              isLoading={this.state.isLoadingComplete}
              saveCurrentlyVisibleColumns={this.saveCurrentlyVisibleColumns}
              addIconsToGDTableHeadersList={addIconsToGDTableHeadersList}
              titleRequired={true}
              isCheckboxOnRowRequired={this.state.queueMetaData.isCheckboxOnRowRequired}
              recordCountRequired={this.state.queueMetaData.recordCountRequired}
              isFetchingData={false}
              openBoxDropDownStyle={{
                width: 150,
                marginLeft: -53,
                fontSize: 'initial',
              }}
              agLoader={this.state.agLoader}
              userPermissions={this.state.userPermission}
              exportFileName={this.state.tableName}
              customFooter={
                <div
                  style={{ borderTop: "0px", paddingRight: "16px" }}
                  className='customFooterButtonContainer'
                >
                  <Button action={this.onCloseButtonClick} >
                    <span className='customFooterButtonRelatedCase'>Close</span>
                  </Button>
                </div>
              }
            />
          </div>
        }

        {!(this.state.dataErr || this.state.tabLimitExceed || this.state.isCaseFailedToLoad) && !this.state.isLoading && (
          <div className={mainContentClass}>
            {!(this.state.dataErr || this.state.tabLimitExceed) && (
              <span>
                <div className={this.mainHeaderClass()}
                  style={
                    this.props.isSearchActive === false &&
                      this.state.isrelatedSearchLoaded === false
                      ? this.props.caseNumber
                        ? (this.state.isOp1 || this.state.isLtype || this.state.caseLandingData.caseStageDetail.disputeStageName === UNIDENTIFIED_STAGE)
                          ? { top: 85, paddingLeft: 0 }
                          : { top: 144, paddingLeft: 0, marginBottom: -60, borderTop: 'none' }
                        : undefined
                      : (this.props.caseNumber && !(this.state.isOp1 || this.state.isLtype) && this.props.isSearchActive === false && this.state.isrelatedSearchLoaded === false)
                        ? { zIndex: 1, top: 144, paddingLeft: 0, borderTop: 'none' }
                        : { top: 144, paddingLeft: 0, marginBottom: -60, borderTop: 'none' }
                  } >
                  <div className={this.caseHeader(CASE_HEADER_CONTAINER)}> {this.props.caseNumber && !(this.state.isOp1 || this.state.isLtype) &&
                    <CaseLandingGetNextHeader
                      getNextDisable={getNextDisable || false}
                      prevCaseNumber={this.props.caseNumber}
                      prevCaseStageId={this.state.caseStageId}
                      getTakeActions={this.performTakeAction}
                      isReadOnly={this.state.isReadOnly}
                      disableTakeAction={this.state.disableTakeAction}
                      selectList={this.state.selectList}
                      caseLandingData={this.state.caseLandingData}
                      getIsLoadingStatus={this.getIsLoadingStatus}
                      toggleDrawer={this.toggleDrawer}
                      getApiDrawerData={this.getApiDrawerData}
                      caseLandingHistory={this.state.caseLandingData.caseHistory}
                    />}
                    <div className={this.caseHeader(CASE_HEADER_INNER)} >
                      {
                        this.props.auth.user && this.props.auth.user.parsedPermissions && this.props.auth.user.parsedPermissions.case &&
                        this.props.auth.user.parsedPermissions.case.canBookmark && !this.state.isOp1OrWex &&
                        (
                          <span className={this.state.isReadOnly ? "read-only-tooltip bookmark-view" : "bookmark-view"} ><BookMarkIcon toggleBookMark={this.toggleBookMarkIcon} isBookMarked={!this.state.isBookMarked} height="20px" width="20px" /></span>
                        )
                      }
                      <span className="lockedCaseIcon">
                        {this.state.isReadOnly === true && <InformationBubble
                          tooltipContent={"Read Only Mode "}
                        >
                          <img alt="lockicon" className="lockIcon" src={LockIcon} height="20px" width="15px" />
                        </InformationBubble>
                        }
                      </span>
                      <DueDate key={'caseStageDetail.daysToAct'} daysLeft={this.state.caseLandingData?.caseStageDetail?.daysToAct} />
                      <div className='outer'>
                        {!this.state.isOp1OrWex && <div><span className="merchant-region">
                          {this.state.caseLandingData?.caseDetail?.acquirerName + ' ' + this.state.caseLandingData?.caseDetail?.merchantRegionCode}
                        </span>
                          {this.state.caseLandingData?.caseStageDetail?.disputeStageName ? <span className="color-cell merchant-region"><GDColorCodedCell content={`${this.state.caseLandingData.caseStageDetail.disputeStageName}`} /></span> : <span>--</span>}
                        </div>}
                        <div className='case-name-header'>
                          <div className="case-number">
                            <span className="case-label">Case&nbsp;</span>
                            <span className="case-id">#{this.props.caseNumber}</span>
                          </div>{this.state.caseLandingData?.caseHistory && this.state.caseLandingData?.caseHistory.length > 0 && <div className="case-number">
                            <span className="case-label">Stage&nbsp;</span>
                            <span className="case-id">#{this.getLatestStageId(this.state.caseLandingData?.caseHistory)}</span>
                          </div>}
                        </div>
                      </div>
                      {!(this.state.dataErr || this.state.tabLimitExceed) && !this.getIsLoadingStatus() && !this.state.isOp1OrWex && Object.keys(this.state.caseLandingData).length > 0 && <div className="summarybar">
                        <GDTableSummaryRow
                          summaryColumns={this.state.summaryData.summaryColumns}
                          summaryData={[].concat(this.state.caseLandingData)}
                          id='caselanding'
                          extraWidth
                          isCaseLanding
                        />
                      </div>}
                    </div>
                    {this.state.caseLandingData?.activeCaseStageDetail != null &&
                      <div style={{ marginBottom: -40, borderTop: 'none' }} >
                        <FinancialsBanner
                          extraclass='active-stage-warning'
                          title={'Warning: A stage other than the most recent is active. Ensure the correct stage is reactivated immediately after taking action on stage #' + `${this.state.caseLandingData?.activeCaseStageDetail?.caseStageId}` + '.'}
                          image={financialsLogo}
                          imageClass="financials-logo"
                        />
                      </div>
                    }
                  </div>
                </div>
              </span>
            )}

            <div className={this.mainContentWrapper()} >
              {this.state.isSubmitting && <div className="modal"> <div className="ball-sync-loader loader" style={{
                height: 200, marginRight: '20%'
              }}><BVLoader20 /></div> </div>}
              {(this.state.isOp1OrWex || this.state.isLtype) && this.state.exceptionQueueCaseDetail && !this.getIsLoadingStatus() &&
                <FormGroupControl
                  primaryActionButtonText={this.state.exceptionQueueCaseDetail.primaryActionButtonText}
                  onClickCancelButton={this.goToPreviousPage}
                  onClickPrimaryActionButton={this.submitAndUpdateExceptionCases}
                  columns={this.state.exceptionQueueCaseDetail.dataColumns}
                  formTitle={this.state.exceptionQueueCaseDetail.title}
                  formWidth={this.state.exceptionQueueCaseDetail.formWidth}
                  wrapperWidth={this.state.exceptionQueueCaseDetail.wrapperWidth}
                  inputBoxWidth={this.state.exceptionQueueCaseDetail.inputBoxWidth}
                  textAreaWidth={this.state.exceptionQueueCaseDetail.textAreaWidth}
                  setDefaultValues={this.setDefaultValues}
                  buttonStyle={this.state.exceptionQueueCaseDetail.buttonStyle}
                  cancelButtonStyle={this.state.exceptionQueueCaseDetail.cancelButtonStyle}
                  formGroupExtraStyle={this.state.caseLandingData.caseStageDetail.disputeStageName === UNIDENTIFIED_STAGE ? this.state.exceptionQueueCaseDetail.formGroupExtraStyleUnIdentified : this.state.exceptionQueueCaseDetail.formGroupExtraStyle}
                  formWrapperStyle={this.state.exceptionQueueCaseDetail.formWrapperStyle}
                  formMarginBottom={this.state.exceptionQueueCaseDetail.formMarginBottom}
                />
              }

              {this.state.selectedActionPanelDetailItem !== undefined && this.state.isIssuerActionSelected == false && !this.state.isReadOnly && (

                <ActionPane
                  getSubmitActionStatus={this.getSubmitActionStatus}
                  caseNumber={this.props.caseNumber}
                  caseStageId={this.state.caseLandingData.activeCaseStageDetail != null ? this.state.caseLandingData.activeCaseStageDetail.caseStageId : this.state.caseLandingData.caseStageDetail.caseStageId}
                  selectedActionId={this.state.selectedActionId}
                  selectedActionPanelDetailItem={this.state.selectedActionPanelDetailItem}
                  setNotification={this.props.setNotification}
                  resetActionPane={this.resetActionPane}
                  // getCaseLandingData={this.getCaseLandingData} //change
                  closeNotification={this.props.closeNotification}
                  cancelOnly={this.props.cancelOnly}
                  setCaseStatus={this.setCaseStatus}
                  isDataUploaded={this.state.isDataUploaded}
                  cardBrandCode={this.state.caseLandingData.caseStageDetail.cardBrandCode}
                  resetCaseData={this.resetCaseData}
                  userName={this.props.auth.user.firstName + ' ' + this.props.auth.user.lastName}
                  lastName={this.props.auth.user.lastName}
                  userId={this.props.auth.user.userId}
                />
              )}
              {this.state.isIssuerActionSelected && !this.state.isReadOnly && (
                <IssuerActions
                  getSubmitActionStatus={this.getSubmitActionStatus}
                  caseNumber={this.props.caseNumber}
                  caseStageDetail={this.state.caseLandingData.activeCaseStageDetail || this.state.caseLandingData.caseStageDetail}
                  latestCaseStageId={this.state.caseLandingData.caseStageDetail.caseStageId}
                  transactioncode={this.state.caseLandingData.caseDetail.transactionCode}
                  merchantNumber={this.state.caseLandingData?.merchantDetail?.merchantNumber}
                  languageIndCode={this.state.caseLandingData?.merchantDetail?.languageIndCode}
                  selectedActionId={this.state.selectedActionId}
                  selectedActionPanelDetailItem={this.state.selectedActionPanelDetailItem}
                  setNotification={this.props.setNotification}
                  resetActionPane={this.resetActionPane}
                  closeNotification={this.props.closeNotification}
                  setCaseStatus={this.setCaseStatus}
                  isDataUploaded={this.state.isDataUploaded}
                  acquirerCode={this.state.caseLandingData.caseDetail.acquirerName}
                  merchantRegionCode={this.state.caseLandingData.caseDetail.merchantRegionCode}
                  actionViewCode={this.state.actionViewCode}
                  takeActionPageDetail={this.state.caseLandingData.takeActionPageDetail}
                  submitActionOption={this.state.submitActionOption}
                  resetCaseData={this.resetCaseData}
                  dataErr={(!this.state.caseLandingData.takeActionPageDetail || (this.state.caseLandingData.takeActionPageDetail && this.state.caseLandingData.takeActionPageDetail.length == 0)) ? true : (this.state.dataErr || this.state.tabLimitExceed)}
                  merchantCurrencyCode={this.state.caseLandingData.caseDetail.merchantPaymentCurrencyCodeDesc}
                  transactionDate={this.state.caseLandingData.caseDetail.transactionDate}
                  disputeCurrencyCode={this.state.caseLandingData.caseDetail.disputeCurrencyCodeDesc}
                  userPermissions={this.props.auth.user.parsedPermissions}
                  foreignDomesticIndicator={this.state.caseLandingData.caseDetail.foreignDomesticIndicator}
                  isCreditChargebackInd={this.state.caseLandingData.caseDetail.isCreditChargebackInd}
                  isActiveStagePresent={this.state.caseLandingData?.activeCaseStageDetail != null}
                  cardBrandDueDate={this.state.caseLandingData.caseStageDetail.cardBrandRespondDueDate}
                  userId={this.props.auth.user.userId}
                  isAnnex19DocPresent={this.state.caseLandingData.caseDetail.isAnnex19Present}
                />
              )}
              <div className={this.overviewContainer()}>
                {!(this.state.dataErr || this.state.tabLimitExceed) && !this.state.isCaseFailedToLoad && !this.state.isLoading && this.state.caseLandingData && data.map((element, index) => {
                  return (
                    <OverviewPane
                      key={index}
                      element={element}
                      id={element.id}
                      findHeight={this.findHeight}
                      divHeight={Math.max(...this.state.divHeightArray)}
                      caseNumber={this.props.caseNumber}
                      dataColumns={element.dataColumns}
                      data={this.state.caseLandingData}
                      accountingData={this.state.caseLandingData.accountDetail}
                      gotoExtraCaseDetailsPage={this.gotoExtraCaseDetailsPage}
                      isReadOnly={this.state.isReadOnly}
                      dateFormat={this.props.preferences.dateFormat}
                      timeFormat={this.props.preferences.timeFormat}
                      getRelatedCaseSearchData={this.state.isrelatedSearchLoaded ? () => { } : this.getRelatedCaseSearchData}
                      getRelatedTransactionSearchData={this.props.isRelatedTransactionGridLoaded ? () => { } : this.getRelatedTransactionSearchData}
                      isInvestigatorPortal={true}
                      caseHistory={this.state.caseLandingData.caseHistory}
                    />
                  );
                })}
              </div>
              {!this.state.isCaseFailedToLoad && !this.state.isLoading && !this.state.isOp1OrWex && <center>
                <div className="moredetails">
                  <Divider>
                    <HollowButton action={this.toggle}>{this.state.isExpanded ? 'Hide More Details' : 'View More Details'}</HollowButton>
                  </Divider>
                </div>
              </center>
              }
            </div>
          </div>
        )}

        {
          this.props.auth.user.parsedPermissions.case.viewCaseHistory && !this.state.isOp1OrWex && this.props.caseNumber && !this.state.isLoading &&
          <TimeLineSection
            isReadOnly={this.state.isReadOnly}
            caseNumber={this.props.caseNumber}
            auth={this.props.auth}
            caseLandingHistory={this.state.caseLandingData.caseHistory}
            historyData={this.state.caseLandingData.historyData}
            historyDataErr={this.state.historyDataErr}
            historyDataLoading={this.state.historyDataLoading}
            // getCaseHistory={this.getCaseHistory}
            callUnlinkBanner={this.callUnlinkBanner}
            toggleDrawer={this.toggleDrawer}
            getApiDrawerData={this.getApiDrawerData}
            configId={this.state.configId}
            dateFormat={this.props.preferences.dateFormat}
            timeFormat={this.props.preferences.timeFormat}
            cardBrandCode={this.state.caseLandingData.caseDetail ? this.state.caseLandingData.caseDetail.cardBrandCode : ''}
            isCaseFailedToLoad={this.state.isCaseFailedToLoad}
            getCaseDetails={this.props.fetchCase}
            getFetchCaseLoader={this.getFetchCaseLoader}
            setActiveStageIndicatorSettingsOpenFlag={this.props.setActiveStageIndicatorSettingsOpenFlag}
          />}
        {
          this.state.questionireData && this.state.drawerOpen && this.state.questionDrawer && (
            <div className="drawer open">
              <QuestionireDetailView
                type="report"
                data={this.state.questionireData}
                goBack={this.toggleDrawer}
                structure={[].concat(getDrawerData(this.state.configId, this.state.questionireData))}
                hideFlag={true}
                preferences={{}}
                // gotoExtraCaseDetailsPage={this.gotoNewTabPage}
                configId={this.state.configId}
                caseStageId={this.state.caseStageId}
                isdataLoading={this.state.isdataLoading}
                drawerdataErr={this.state.drawerdataErr}
                isInternalUser={true}
                newTabToggle={false}
                isReadOnly={this.state.isReadOnly}
              />
            </div>
          )}
        {
          this.state.drawerData && this.state.drawerOpen && !this.state.questionDrawer && (
            <div className="drawer open">
              <GDDetailView
                type="report"
                data={this.state.drawerData}
                goBack={this.toggleDrawer}
                structure={[].concat(getDrawerData(this.state.configId, this.state.drawerData))}
                hideFlag={true}
                preferences={{}}
                gotoExtraCaseDetailsPage={this.gotoNewTabPage}
                configId={this.state.configId}
                caseStageId={this.state.caseStageId}
                isdataLoading={this.state.isdataLoading}
                drawerdataErr={this.state.drawerdataErr}
                isInternalUser={true}
                newTabToggle={true}
                isReadOnly={this.state.isReadOnly}
                caseLandingHistory={this.state.caseLandingData.caseHistory}
                caseHeaderDrawer={this.state.caseHeaderDrawer}
              />
            </div>
          )}
      </div>
    );
  }
}


CaseLanding.propTypes = {
  auth: PropTypes.object,
  addCaseToRecentAction: PropTypes.func.isRequired,
  addCurrentCaseNumber: PropTypes.func,
  banner: PropTypes.object,
  cancelOnly: PropTypes.bool,
  historyData: PropTypes.array,
  closeNotification: PropTypes.func,
  isSearchActive: PropTypes.bool,
  location: PropTypes.object,
  match: PropTypes.object,
  notification: PropTypes.object,
  resetNestedFieldSelectorData: PropTypes.func.isRequired,
  setNotification: PropTypes.func,
  setDangerNotification: PropTypes.func,
  setWarningNotification: PropTypes.func,
  isRelatedTransactionGridOpen: PropTypes.bool
};

CaseLanding.defaultProps = {
  auth: {},
  banner: {},
  // caseHistory: [],
  historyData: [],
  closeNotification: () => { },
  isSearchActive: false,
  location: {},
  match: {},
  notification: {},
  isRelatedTransactionGridOpen: false,
  setNotification: () => { },
  setDangerNotification: () => { },
  setWarningNotification: () => { },
  addCurrentCaseNumber: () => { },
  setSearchType: () => { },
  openCases: [],
  amexDisputeStages: [],
  activeCases: []
};

function reloadPage() {
  window.location.reload(true);
  window.scrollTo(0, 0);
}

const mapStateToProps = (state) => ({
  dataColumns: state.dataColumns?.columns,
  auth: state.auth,
  banner: state.notification.banner[0],
  notification: state.notification,
  isSearchActive: state.appSearch.isSearchActive,
  isUserAuthenticated: isUserAuthenticatedSelector(state),
  isRelatedTransactionGridOpen: state.toggleAppSearchPanelReducer.isRelatedTransactionGridOpen,
  isRelatedTransactionGridLoaded: state.toggleAppSearchPanelReducer.isRelatedTransactionGridLoaded,
  TransactionSearchType: state.appSearch.pageId,
  dataSearchNextPage: state.toggleAppSearchPanelReducer.dataSearchNextPage,
  dataSearchPrevPage: state.toggleAppSearchPanelReducer.dataSearchPrevPage,
  dataTransactionGridStatus: state.toggleAppSearchPanelReducer.dataTransactionGridStatus,
  openCases: state.caseInfo.openCases,
  amexDisputeStages: state.caseInfo.disputeStages.amexDisputeStages,
  activeCases: state.activeCases,
});

const mapDispatchToProps = (dispatch) => {
  return {
    fetchDataColumns: (pageId) => {
      dispatch(fetchDataColumns(pageId));
    },
    addCaseToRecentAction: (caseNumberToAdd) => {
      dispatch(addCaseToRecent(caseNumberToAdd));
    },
    addCurrentCaseNumber: (casenumber) => {
      dispatch(addCurrentCaseNumber(casenumber));
    },
    setDrawerOpenFlag: (isDrawerActive) => {
      dispatch(setDrawerOpenFlag(isDrawerActive));
    },
    setNotification: (banner) => dispatch(addInternalCaseNotificationBanner(banner)),
    closeNotification: () => dispatch(closeNotificationBanner()),
    resetNestedFieldSelectorData: (dataToBeUpdated) => dispatch(resetNestedFieldSelectorData(dataToBeUpdated)),

    toggleAppSearchPanelAction: (isRelatedTransactionGridOpen) => {
      dispatch(toggleAppSearchPanelAction(isRelatedTransactionGridOpen));
    },
    setMerchantDetailsAction: (merchantDetails) => {
      dispatch(setMerchantDetailsAction(merchantDetails));
    },
    setSearchOpenFlag: (isSearchActive) => {
      dispatch(setSearchOpenFlag(isSearchActive));
    },
    setRelatedGridLoadedAction: (isRelatedTransactionGridLoaded) => {
      dispatch(setRelatedGridLoadedAction(isRelatedTransactionGridLoaded));
    },
    setDataSearchTrasactionGridProp: (dataTransactionGridStatus, dataSearchPrevPage, dataSearchNextPage) => {
      dispatch(setDataSearchTrasactionGridProp(dataTransactionGridStatus, dataSearchPrevPage, dataSearchNextPage));
    },
    setAmexDisputeReasonCode: (amexDisputeReasonCode) => {
      dispatch(setAmexDisputeReasonCode(amexDisputeReasonCode));
    },
    fetchOp1Case: (caseStageId) => {
      dispatch(fetchOp1Case(caseStageId));
    },
    fetchAmexDisputeStages: () => {
      dispatch(fetchAmexDisputeStages());
    },
    fetchCase: (caseNumber, isView) => {
      dispatch(fetchCase(caseNumber, isView));
    },
    unloadCaseInfo: (caseNumber) => {
      dispatch(unloadCaseInfo(caseNumber));
    },
    unloadCaseAsActive: (caseNumber, caseStageId) => {
      dispatch(unloadCaseAsActive(caseNumber, caseStageId));
    },
    resetCaseUpdateFlag: (caseNumber) => {
      dispatch(resetCaseUpdateFlag(caseNumber));
    },
    revisitCase: (caseNumber) => {
      dispatch(revisitCase(caseNumber));
    },
    resetCaseRevisitFlag: (caseNumber) => {
      dispatch(resetCaseRevisitFlag(caseNumber));
    },
    setActiveStageIndicatorSettingsOpenFlag: (isActiveStageIndicatorSettingsEnabled) => {
      dispatch(setActiveStageIndicatorSettingsOpenFlag(isActiveStageIndicatorSettingsEnabled));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CaseLanding);
